const _ = require("lodash");
const moment = require("moment");
const React = require("react");
const Link = require("../../core/view/Link");
const URLMake = require("../../../shared/URLMake");
const HoverButton = require("../HoverButton");
const HistoryIcon = require("../HistoryIcon");
const StringUtil = require("../../../shared/StringUtil");
const Avatar = require("../../core/view/Avatar");
const dbShop = require("../../../shared/data/dbShop.json");
const OpsCart = require("../vault/OpsCart");
const OpsUser = require("../../core/vault/OpsUser");
const {
	MAX_SUBSCRIPTIONS_FOR_PARENT,
	MAX_INACTIVE_SUBSCRIPTIONS_FOR_PARENT,
	ALLOWED_CLASS_GRADES,
} = require("../../../shared/Constants");
const {getDisplayedGradeLabel} = require("../../../shared/SchoolUtil");
const BundleSelectStyles = require("../styles/BundleSelectModal.css");
const infoStyles = require("../styles/InfoStyles.css");
const {KB_URLS} = require("../../../shared/KnowledgeBase");
const {
	HEAR_ABOUT_BA_SURVEY_TITLE,
	HEAR_ABOUT_BA_SURVEY_OPTIONS,
} = require("../../../shared/hearAboutBaSurvey");
const {getStudentRegistrationPage} = require("../../core/vault/OpsPage");
const {getFeatureFlag} = require("../../core/util/FeatureFlags");

//Home - How section
const getHowViewCopy = function() {
	return {
		books: `The Beast Academy book series is a full math curriculum for ages 6\u201113. Beautifully
            illustrated Guides offer engaging math instruction, while Practice books include hundreds of problems
            and puzzles that reinforce the concepts learned in the Guides.`,
		online: `Beast Academy online is an online learning system that provides practice, puzzles, games, and detailed progress reporting, as well as online versions of the Beast Academy Guide books.`,
	};
};

const getApparelDescription = function(apparelHash) {
	// If we ever add other kinds of apparel, we can add logic here to determine
	// the right description. For now, use the only one we have.
	return {
		description: (
			<div>
				{"Do math in style with the whole Beast Academy crew!"}
				<br />
				{"100% preshrunk cotton T\u2011shirt."}
			</div>
		),
		availableIn: `Available in youth and adult sizes.`,
	};
};

// Bottom bar
const getBottomBarCopy = function() {
	return {
		menu: [
			{
				title: "aops programs",
				items: ["AoPS Online", "Beast Academy", "AoPS Academy"],
				links: ["//artofproblemsolving.com", "home", "//aopsacademy.org"],
			},
			{
				title: "about",
				items: ["About Us", "Our Team", "Jobs"],
				links: [
					URLMake.forAbout(),
					"//artofproblemsolving.com/company/staff",
					"//artofproblemsolving.com/company/careers",
				],
			},
			{
				title: "site info",
				items: ["Terms", "Privacy", "Contact Us", "FAQ", "Help Site"],
				links: [
					URLMake.forTerms(),
					URLMake.forPrivacy(),
					URLMake.forContact(),
					URLMake.forFAQ(),
					"//help.beastacademy.com",
				],
			},
			{
				title: "resources",
				items: [
					"Placement Tests",
					"Planning",
					"Printables",
					"Backgrounds",
					"Playground",
					getFeatureFlag("ENABLE_DAILY_PUZZLES") ? "Daily Puzzles" : "All Ten",
					"Gift a Subscription",
				],
				links: [
					"/resources/placementtests",
					"/resources/planning",
					"/resources/printables",
					"/resources/backgrounds",
					"/playground",
					getFeatureFlag("ENABLE_DAILY_PUZZLES")
						? "/puzzles/daily"
						: "/all-ten",
					"/gift",
				],
			},
		],
		socialMedia: {
			icons: ["facebook", "pinterest"],
			links: [
				"//facebook.com/beastacademymath",
				"https://www.pinterest.com/AoPS_Beast_Academy/",
			],
		},
	};
};

//For the Contact page
const getContactCopy = function(messageLength, styles = {}) {
	return {
		aboveForm: (
			<div>
				{"Can't find the answer to your question on our "}
				<Link to={URLMake.forFAQ()} className={styles.linkOnBlue}>
					FAQ
				</Link>
				{" , or need technical support?"}
				<br />
				Fill out the form below and we'll respond as soon as possible.
			</div>
		),
		reasonTitle: "Reason for Contact",
		reasons: {
			general: "Recommendations",
			orders: "Orders and Sales",
			books: "Beast Academy Books",
			online: "Beast Academy Online",
			tech: "Technical Support",
			other: "Other Reason",
		},
		//The short reasons aren't displayed to users, but make for shorter email subjects in the forms we receive.
		//They are optional (don't need to be specified for all reasons unless there is a shorter version).
		shortReasons: {
			tech: "Tech Support",
			books: "Book Info",
			online: "Online Info",
			other: "Contact",
		},
		roleTitle: "I am a",
		//These appear if the user submits the Contact form with something missing/incorrect.
		errorMessages: {
			missingReason: "You must choose a reason for contact.",
			missingRole: "You must choose the role that best describes you.",
			emptyFields: "Required fields are empty.",
			invalidEmail: "Please enter a valid email address.",
			messageLength: `The message must be at least ${messageLength} characters long.`,
			mismatchEmails: "Email addresses must be the same.",
		},
		sendingText: "Your message is sending.",
		successMessage: (
			<div>
				Thank you for your email.
				<br />
				We will be in touch soon.
			</div>
		),
		failText: "There was an error sending your email.",
		retryText: "Click the button below to retry.",
		laterText: "Please try again later.",
	};
};

const getBookOffers = function(offerClass, percentClass, useSpans) {
	return [1, 2].map(multiplier =>
		React.createElement(
			useSpans ? "span" : "div",
			{className: offerClass || "", key: "offer-" + multiplier},
			"Save ",
			<span className={percentClass}>{multiplier * 10 + "%"}</span>,
			" when you order " +
				multiplier * 5 +
				" or more copies of a single book title."
		)
	);
};

const getCodeOffers = function(offerClass, percentClass, useSpans) {
	return [1, 2].map(multiplier =>
		React.createElement(
			useSpans ? "span" : "div",
			{className: offerClass || "", key: "offer-" + multiplier},
			"Save ",
			<span className={percentClass}>{multiplier * 10 + "%"}</span>,
			" when you order " + multiplier * 5 + " or more yearly codes."
		)
	);
};

const getCheckoutConfirmCopy = function(
	hasSubscriptionItems = null,
	email = null,
	isEmailVerified = null
) {
	let checkoutConfirmationTitle = "Order placed!";
	let checkoutConfirmationSubtitle = "We emailed your receipt.";
	let resendEmailButtonText = "Resend email";

	if (!email) {
		checkoutConfirmationSubtitle =
			"We emailed your receipt. Check your spam folder if you don’t see it.";
	} else if (isEmailVerified) {
		checkoutConfirmationSubtitle = "We sent a receipt to " + email + ".";
		if (hasSubscriptionItems) {
			checkoutConfirmationSubtitle += " Now, let's get you set up.";
			resendEmailButtonText = "Let's go";
		} else {
			checkoutConfirmationSubtitle +=
				" Check your spam folder if you don’t see it.";
		}
	} else {
		if (hasSubscriptionItems) {
			checkoutConfirmationTitle += " Verify your email to get started.";
			checkoutConfirmationSubtitle =
				"We sent a receipt and a verification email to " +
				email +
				". Check your spam folder if you don’t see them.";
			resendEmailButtonText = "Resend emails";
		} else {
			checkoutConfirmationSubtitle =
				"We sent a receipt to " +
				email +
				". Check your spam folder if you don’t see it.";
		}
	}

	return {
		checkoutConfirmationTitle: checkoutConfirmationTitle,
		checkoutConfirmationSubtitle: checkoutConfirmationSubtitle,
		resendEmailButtonText: resendEmailButtonText,
		resendEmailsLoading: "Sending…",
		sending: "Please wait while your order is being placed...",
		success: "You will receive an order confirmation by email.",
		subscriptionSuccess:
			"You will receive an order confirmation and instructions for Student Account setup by email.",
		subscriptionChange:
			"Your subscription was successfully changed. You will receive a confirmation by email.",
		spam: "Don't see your confirmation email? Check your spam folder.",
		fail: "Something went wrong with the order submission.",
		later: "Please try again later.",
		retry: "Click here to try submitting again.",
		localAcademy:
			"Have you heard of AoPS Academy? There's a campus near you! Click here to learn more.",
	};
};

const getShippingCopy = function() {
	return {
		"us-economy": "2 to 3 weeks delivery time",
		canada: "1 to 2 weeks delivery time",
		international: "1 to 3 weeks delivery time",
		"us-priority": "3 to 7 business days delivery time",
		extra:
			"Economy shipping is free on orders with $100 or more in books. Not available to US overseas territories.",
	};
};

const getFormErrorCopy = function() {
	return {
		general: `Review the item(s) noted in red to continue.`,
		E_MISSING: `This field is required.`,
		invalidAddressGroup: `Invalid address.`,
		apartmentNeedsSpace: `Invalid address. Try adding a space after `,
		apartmentNeedsPrefix: `Invalid address. Try adding a prefix (e.g. Apt) before `,
	};
};

const shippingTypes = {
	"us-economy": "US Economy",
	"us-priority": "US Priority",
	canada: "Canada",
	international: "International",
};

const getFormInvalidCopy = function(checkType) {
	const table = {
		phone: {
			E_MISSING: "Please enter a phone number.",
			E_LENGTH: "Phone number must be between 4-20 digits.",
			E_BAD_CHAR: "Phone number has invalid characters.",
			E_INVALID_VALUE: "Phone number has invalid characters.",
		},
		"us-zipcode": {
			E_MISSING: "Please enter a zip code.",
			E_LENGTH: "Invalid US zip code.",
			E_BAD_CHAR: "Zip code has invalid characters.",
			E_INVALID_VALUE: "Invalid US zip code.",
		},
		"canada-zipcode": {
			E_MISSING: "Please enter a zip code.",
			E_LENGTH: "Invalid Canadian postal code.",
			E_BAD_CHAR: "Zip code has invalid characters.",
			E_INVALID_VALUE: "Invalid Canadian postal code.",
		},
		zipcode: {
			E_MISSING: "Please enter a zip code.",
			E_LENGTH: "Postal codes cannot be longer than 20 characters.",
			E_BAD_CHAR: "Postal code has invalid characters.",
		},
		name: {
			E_MISSING: "Please enter a name.",
			E_LENGTH: "Name must be at least 4 characters.",
			E_BAD_CHAR: "Name has invalid characters.",
		},
		firstName: {
			E_MISSING: "Please enter a first name.",
			E_LENGTH: "First name must be at least 4 characters.",
			E_BAD_CHAR: "First name has invalid characters.",
		},
		lastName: {
			E_MISSING: "Please enter a last name.",
			E_LENGTH: "Last name must be at least 4 characters.",
			E_BAD_CHAR: "Last name has invalid characters.",
		},
		address1: {
			E_MISSING: "Please enter an address.",
			E_LENGTH: "Address 1 must be more than 4 characters.",
			E_BAD_CHAR: "Address 1 has invalid characters.",
		},
		address2: {
			E_MISSING: "Please enter an address.",
			E_LENGTH: "Address 2 must be more than 1 character.",
			E_BAD_CHAR: "Address 2 has invalid characters.",
		},
		city: {
			E_MISSING: "Please enter a city.",
			E_LENGTH: "City must be more than 2 characters.",
			E_BAD_CHAR: "City has invalid characters.",
		},
		state: {
			E_MISSING: "Please enter a state.",
			E_LENGTH: "Province/states cannot be longer than 40 characters.",
			E_BAD_CHAR: "Province/states has invalid characters.",
		},
		country: {
			E_MISSING: "Please enter a country.",
			E_LENGTH: "Country values must be chosen from the list.",
			E_BAD_CHAR: "Country values must be chosen from the list.",
		},
		method: {
			E_MISSING: "Please choose a shipping method.",
		},
		email: {
			E_MISSING: "Please enter an email.",
			E_LENGTH: "Email must be fewer than 100 characters.",
			E_BAD_CHAR: "Email address has invalid characters.",
			E_INVALID_VALUE: "Invalid email address.",
		},
		comments: {
			E_LENGTH: "Comments cannot be longer than 1000 characters.",
			E_BAD_CHAR: "Comments contain invalid characters.",
		},
		cvv: {
			E_MISSING: "Please enter a CVV.",
			E_LENGTH: "CVV must be 3-4 characters.",
			E_BAD_CHAR: "CVV has invalid characters.",
		},
		cardNumber: {
			E_MISSING: "Please enter a number.",
			E_BAD_CHAR: "Credit card number has invalid characters.",
			E_INVALID_VALUE: "Invalid credit card number.",
		},
		expMonth: {
			E_MISSING: "Please enter an expiration date.",
			E_INVALID_VALUE: "Expiration cannot be in the past.",
		},
		password: {
			E_MISSING: "Please enter a password.",
			E_INVALID_PASSWORD: "Invalid password.",
			E_NO_PASSWORD: "Please enter a password.",
			E_PASSWORD_IS_EMAIL: "Password cannot include your email.",
			E_PASSWORD_TOO_SHORT: "Password must be at least 5 characters.",
			E_DISPLAY_NAME_IN_PASSWORD: "Password cannot include student name.",
			E_PASSWORD_IS_USERNAME: "Password cannot include username.",
			E_USERNAME_IN_PASSWORD: "Password cannot include username.",
			E_PASSWORD_IS_ID: "Password cannot include email or username.",
			E_SHORT_PASSWORD: "Password must be at least 8 characters.",
			E_LONG_PASSWORD: "Password must be less than 4096 characters.",
			E_COMMON_PASSWORD: "Password is too common.",
			E_INVALID_CURRENT_PASSWORD: "Current password is incorrect.",
			E_EMAIL_PASSWORD_INVALID:
				"Min. 8 characters with 1 non-alphabetic character.",
			E_NO_USERNAME:
				"Password could not be updated. Please contact us at support@beastacademy.com for assistance.",
			E_NEW_PASSWORD_MISSING: "Please enter a new password.",
			E_NEW_PASSWORD_REPEAT_MISSING: "Please repeat the new password.",
			E_PASSWORD_MISMATCH: "New passwords must match.",
			E_OLD_PASSWORD_MISSING: "Please enter your current password.",
		},
		passwordRepeat: {
			E_PASSWORD_REPEAT_MISMATCH: "Passwords must match.",
		},
		displayName: {
			E_MISSING: "Please enter a name.",
			E_BAD_CHAR: "Student nicknames may only include letters.",
			E_LENGTH: "Student nicknames must be fewer than 15 characters.",
			E_DUPLICATE_NAME: "Student nicknames must be unique.",
		},
		redeemCode: {
			E_NON_PARENT_REDEEM:
				"Your BAO account is not eligible to use subscription codes. Codes can only be redeemed in a Parent account.",
			E_NO_CODE: "Invalid code.",
			E_MISSING_CODE: "Missing code.",
			E_CODE_EXPIRED: "This code is expired.",
			E_CODE_USED: "This code has already been used.",
			E_CODE_TYPE_MISMATCH: "Invalid code.",
			E_DUPLICATE_CODE: "Codes cannot be reused.",
			E_INVALID_LENGTH: "Code must be 7 characters after the hyphen.",
		},
		taxpayerID: {
			E_TAXPAYER_ID_INVALID: "Invalid CPF or CNPJ.",
		},
		cartItems: {
			E_SUBSCRIPTION_IN_CLASSWALLET_CART:
				"Subscriptions cannot be purchased through ClassWallet.",
		},
	};
	return table[checkType] || "";
};

const getCouponErrorCopy = function() {
	return {
		E_INVALID_INPUT: "You must provide a coupon code.",
		// TODO: CouponUtil provides a moreInfo with the item type; we can get that
		// into this message if we want.
		E_NO_MATCHING_ITEMS:
			"Your cart does not have items that this coupon applies to.",

		E_NO_UNBUNDLED_SUBSCRIPTION:
			"You must have a Yearly subscription that is not part of a Bundle subscription to apply this coupon.",

		E_NO_MONTHLY_OR_YEARLY:
			"This coupon can only be used for a new Monthly or Yearly subscription to BA Online. Books, Bundles, and t-shirts are not eligible. Limit one per customer.",

		E_NO_YEARLY_SUBSCRIPTIONS:
			"This coupon can only be used for a new Yearly subscription or bundle to BA Online. Books and t-shirts are not eligible. Limit one per customer.",

		E_NO_SUBSCRIPTIONS:
			"This coupon can only be used for a new Monthly, Yearly, or Bundle subscription to BA Online. Books and t-shirts are not eligible. Limit one per customer.",

		E_NO_GRADE_SETS:
			"You must have a full grade level of books that are not part of a Bundle subscription to apply this coupon.",

		E_EXISTING_ACCOUNT: "This coupon is for new customers only.",

		E_INVALID_COUPON: "That is not a valid coupon code.",

		E_COUPON_USED: "This coupon has already been used.",

		// catch-all
		default: "There was an issue applying that coupon code. Please try again.",
	};
};

const getCvvBlurb = function() {
	return `Visa, MasterCard, or Discover Card: This is the 3-digit code on the back of
          your card, in the signature field, after the card number. American Express:
          This is the 4-digit code on the front of your card.`;
};

const get404Copy = function() {
	return {
		message: "Oh no! The page you requested cannot be found.",
		home: "Click here to go home.",
	};
};

const getEmailModalCopy = function() {
	return {
		//For the titles of the sections:
		enterEmail:
			"Enter your email to receive updates on new books and content from Beast Academy.",
		pickRole: "Which role best describes you?",
		signingUp: "We are signing you up...",
		signUpSuccess: <span>{"Thanks for signing up!"}</span>,
		signUpFail: "There was an issue signing you up.",
		duplicateEmail: "You are already signed up for our mailing list.",
		//Agreement checkbox
		agreement:
			`I confirm that I am 16 years old or older, and I consent to receive Beast Academy communications,` +
			` including product updates, announcements, and other outreach emails. All such emails include a link that` +
			` can be used to unsubscribe from these emails at any time.`,
		//Errors
		roleNotChosen: "* You must choose a role.",
		agreeNotChecked: "* You must agree to the terms.",
		emailMissing: "* Email address empty",
		emailInvalid: "* Email address invalid",
		privacyPolicy: (
			<p className="modal-email-privacy">
				View the Beast Academy{" "}
				<a className="modal-email-privacy-link" href="/privacy">
					Privacy Policy
				</a>
				.
			</p>
		),
	};
};

const getMessageModalCopy = function(styles, linkClickAction, extraInfo = {}) {
	const {displayName, userID} = extraInfo;
	return {
		tooManyRequests:
			"You have made too many requests to the server. Please wait several minutes, then refresh and try again.",
		noItemsAddedToCart: "You haven't chosen any items yet.",
		tooManyItemsAddedToCart:
			"You tried to add 100 or more copies of a single item to your cart. Please contact us directly for large orders.",
		contactUsLink: "Click here to contact us.",
		purchaseOrderLink:
			"Click here to contact us directly to order 100 or more copies of any title.",
		badPermissions: "Your account does not have access to view this page.",
		subsThruAccountOnly:
			"Subscriptions cannot be added to an existing Parent Account from the Cart. Add and manage your BA Online subscriptions by visiting your Account page.",
		cannotBuySubs: "You cannot purchase subscriptions with this account.",
		couponRemovedByItemsUpdate:
			"The coupon you added is no longer applicable after your recent items changes and has been removed.",
		redeemCodesFail:
			"The code could not be redeemed. Please contact tech-support@beastacademy.com for help.",
		tooManySubscriptions:
			"You may only have up to " +
			MAX_SUBSCRIPTIONS_FOR_PARENT +
			" subscriptions for any order or account.",
		verifyNewAccountFail:
			"This account could not be created. Please contact tech-support@beastacademy.com for help.",
		checkEmailAddressFail:
			"There was an issue verifying this email address. Please contact tech-support@beastacademy.com for help.",
		badSubscriptionName:
			"Student name must be unique and only have alphabetic characters.",
		ownerAddHitLimit:
			`You may only have up to ${MAX_SUBSCRIPTIONS_FOR_PARENT} active subscriptions ` +
			`and ${MAX_INACTIVE_SUBSCRIPTIONS_FOR_PARENT} total subscriptions.`,
		ownerReactivateHitLimit: `You may only have up to ${MAX_SUBSCRIPTIONS_FOR_PARENT} active subscriptions.`,
		mustSignout: `You must sign out to use this page.`,
		noOwnerPayment: (
			<div>
				Your account has no payment method on file.
				<br /> Click below to add a payment method or{" "}
				<Link
					className={styles.inlineLink}
					noFocus={true}
					isNewTab={true}
					to={URLMake.forRedeemSubscription()}
				>
					redeem a subscription code here.
				</Link>
			</div>
		),
		noOwnerBilling: (
			<div>
				Your account has no billing address on file.
				<br /> Click below to add a billing address or{" "}
				<Link
					className={styles.inlineLink}
					noFocus={true}
					isNewTab={true}
					to={URLMake.forRedeemSubscription()}
				>
					redeem a subscription code here.
				</Link>
			</div>
		),
		noOwnerSwitchWhileFailed: (
			<div>
				<div>
					Uh oh! Something went wrong with the recent renewal of this
					subscription. Changes cannot be made at this time.
				</div>
				<div className={styles.paragraphLeft}>
					<strong>To change this subscription:</strong>
					<br />
					Turn off auto-renew to deactivate the subscription. This may take up
					to 1 hour. You can reactivate with your preferred subscription type.
				</div>
				<div className={styles.paragraphLeft}>
					<strong>To continue with the current subscription:</strong>
					<br />
					Check your billing information. We will attempt renewal within 24
					hours.
				</div>
			</div>
		),
		unregisteredStudent: (
			<span>
				{`${displayName}'s Student Account has not been set up yet. `}
				<Link
					className={styles.inlineLink}
					noFocus={true}
					clickAction={linkClickAction}
					to={getStudentRegistrationPage(userID)}
				>
					Click here to get started.
				</Link>
			</span>
		),
		parentSCSPricesNotDone:
			"Pricing information is still loading. Please wait a bit, then try again.",
		couponInfo: (
			<div>
				<div className={styles.couponTitle}>FlattenTheCurve</div>
				<div className={styles.couponText}>
					<p>
						Help your kids stay sharp while schools are closed with BA Online.
					</p>
					<ul>
						<li>
							Enter the coupon code <b>FlattenTheCurve</b> during checkout for
							$15 off a new Beast Academy Monthly or Yearly subscription. The
							coupon cannot be applied to extend existing subscriptions, but can
							be used to add one new student to an existing parent account.
						</li>
						<li>The code does not apply to Bundle subscriptions or books.</li>
						<li>
							If you have recently purchased a subscription without the coupon
							code and are within the 14-day cancellation period, you may cancel
							the subscription and reactivate it using the coupon code.
						</li>
						<li>Limit one coupon per parent account.</li>
						<li>Expires April 30, 2020.</li>
					</ul>
					<p>
						Questions? Contact{" "}
						<a
							className={styles.inlineLink}
							href="mailto:info@BeastAcademy.com"
						>
							info@BeastAcademy.com
						</a>
						.
					</p>
				</div>
				<div className={styles.cartButton}>
					<HoverButton
						text={"ENROLL"}
						onClick={linkClickAction}
						linkTo={URLMake.forEnroll()}
					/>
				</div>
			</div>
		),
		bookTestUnlockFail:
			"Something went wrong when unlocking the test. " +
			"Please wait a bit, then try again.",
		redesignNotification: (
			<div>
				<div className={styles.textEvenSmaller}>
					You may notice a new monster icon on your Reports pages.
				</div>
				<div className={styles.iconContainer}>
					<HistoryIcon
						hasTrophy={false}
						numStars={2}
						hideStarIcon={true}
						backgroundIconType="bonus"
					/>
				</div>
				<div className={styles.textEvenSmaller}>
					This icon indicates enrichment lessons that go beyond what is
					typically taught in most classrooms.
				</div>
				<div className={styles.textEvenSmaller}>
					These lessons may be considered optional. They are great for students
					who could use an extra challenge or want to learn a new topic.
				</div>
			</div>
		),
		leaderboardsNotification: (
			<div>
				<div className={styles.text}>
					Leaderboards are now available on Beast Academy Online.
				</div>
				<div className={styles.text}>
					Students can now see usernames, avatars, statistics, and rankings of
					other BA Online players. You can adjust access to Leaderboards and
					other settings on your Accounts page.
				</div>
			</div>
		),
	};
};

const getTryAgain = function() {
	return "Something went wrong with your request. Please try again later.";
};

const getMailListPageCopy = function() {
	return {
		confirm: {
			basic: "Thanks for signing up for our mailing list!",
			error:
				"There was an issue confirming your email. Make sure you clicked the confirm button or copied the entire confirmation URL.",
		},
		unsubscribe: {
			emailNotifications: {
				basic:
					"You have been unsubscribed from notifications for this student.",
				error:
					"There was an issue unsubscribing you from notifications for this student.",
				alreadyUnsubscribed: "You have already been unsubscribed.",
			},
			activeCampaign: {
				basic: "You have been unsubscribed from these emails.",
				error: "There was an issue unsubscribing you from these emails.",
				alreadyUnsubscribed: "You have already been unsubscribed.",
			},
		},
	};
};

const getConfirmEmailCopy = function(email) {
	return {
		confirmation: (
			<div>
				{"Your email is confirmed."}
				<br />
				{`Sign in using ${email} to get started.`}
			</div>
		),
		update: (
			<div>
				{`Your new account email has been confirmed.`}
				<br />
				{`You may now use ${email} to sign in.`}
			</div>
		),
		confirmed: <div>{`Your email has already been confirmed.`}</div>,
		invalid: (
			<div>
				{`This email, ${email}, is already in use. Please continue to use your original email to sign in or set a different email on Account page.`}
			</div>
		),
		outdated: (
			<div>
				{`This confirmation URL is outdated. Please make sure you are using the most recent confirmation link from your email.`}
			</div>
		),
		// This is going to be the most common case outside of "confirmation"
		error: (
			<div>
				Email confirmation invalid. Please check if the email is already
				confirmed or that you have entered in the complete URL from your email.
				If you have already confirmed your email address, you can now
				<Link className={infoStyles.link} to="/signin" isExternal={true}>
					{" "}
					Sign In
				</Link>
				.
			</div>
		),
		reminder: (
			<div>
				<p>
					{`An email confirmation was sent to`} <br />
					{`${email}`} <br />
					{`when you enrolled in BA Online.`}
				</p>
				<p>
					{`You must click the CONFIRM button in the`} <br />
					{`email to activate the account before signing`}&nbsp;{`in.`}
				</p>
			</div>
		),
	};
};

const getEnableAutoRenewCopy = function() {
	return {
		enabled:
			"Thanks for turning on automatic renewal! To view your subscriptions and make further changes, go to your Account page.",
		error:
			"There was an issue turning on automatic renewal for your subscription. Sign into your Account page to view your subscriptions and make changes.",
	};
};

const getDeleteCardConfirm = function() {
	return "Are you sure you want to delete this card? Without a payment method on file, you will not be able to renew, add, or change subscriptions.";
};

//Role options for mailing list sign-up.
const getMailingListRoles = function() {
	return ["Parent", "Educator", "Other"];
};

const getDisconnectCopy = function() {
	return {
		basic:
			"Unable to connect. Check your connection and make sure your browser is up to date.",
		submitContact:
			"Unable to connect. Check your connection and make sure your browser is up to date to submit your contact request.",
		emailCoupon:
			"Unable to connect. Check your connection and make sure your browser is up to date to submit your information.",
		emailSignUp:
			"Unable to connect. Check your connection and make sure your browser is up to date to sign up for email updates.",
		getCoupon:
			"Unable to connect. Check your connection and make sure your browser is up to date to enter your coupon.",
		prepareOrder:
			"Unable to connect. Check your connection and make sure your browser is up to date to proceed with checkout.",
		placeOrder:
			"Unable to connect. Check your connection and make sure your browser is up to date to place your order.",
		startPaypal:
			"Unable to connect. Check your connection and make sure your browser is up to date to proceed with PayPal.",
		studentRegistration:
			"Unable to connect. Check your connection and make sure your browser is up to date to continue setting up this Student Account.",
		verifyNewAccount:
			"Unable to connect. Check your connection and make sure your browser is up to date to continue setting up your new account.",
	};
};

const getPOCopy = function() {
	return "Contact us directly for school purchase orders or to order 100 or more copies of any title.";
};

const getCheckoutErrorCopy = function() {
	return {
		prepareOrderNotReady: "You must complete all steps before proceeding.",

		placeOrderNotReady:
			"You must complete all steps before placing your order.",

		cartNotFound:
			"Something went wrong with your cart. Please refresh the page and try again.",

		shippingFieldError:
			"Unable to process shipping information. Please make sure your address is valid and try again.",

		billingFieldError:
			"Unable to process billing information. Please check all your information and try again.",

		prepareOrderFail: "An error occurred. Please try again.",

		prepareOrderTaxCloudFail:
			"Our third-party tax calculation provider is currently having an issue processing this order. Please wait a few hours and try again.",

		prepareOrderZipCodeFail:
			"Unable to process address. Please check your zip code and try again.",

		placeOrderFail: "Unable to place order. Please try again.",

		multipleFailedCheckouts:
			"Your payment method was declined. Please wait a few minutes, try another payment method, or reach out to orders@beastacademy.com if you need help placing this order.",

		cardInvalid:
			"The credit card information you entered is invalid. Please check for errors and try again.",

		cardInvalidExp:
			"The credit card information you entered is invalid. Please check for errors and try again.",

		cardDeclined:
			"Your credit card was declined. Please check the card number, expiration, and CVV or use a different payment method.",

		placeOrderCritical:
			"An error occurred while processing your order.  Please wait a few hours and try again.",

		placeOrderDuplicate: "Your order has already been processed.",

		checkoutServerTimeout:
			"Unable to process payment due to server timeout. Please try again.",

		paypalReset:
			"Your PayPal data was invalid. Please check your data or retry without PayPal.",

		paypalRetry:
			"There was a temporary issue with PayPal. Please wait a bit and try again.",

		cvvMismatch:
			"Your CVV is the wrong length for this card type. Please check for errors and try again.",

		cardTypeNotSupported:
			"Your card type is not supported. Please try a different credit card.",

		captchaUnanswered: "Please confirm you're not a robot. 🤖",

		placeOrderUnknown:
			"Your order might not have been placed successfully.  Please contact us at tech-support@beastacademy.com to resolve this issue.",

		cartCheckedOut:
			"You already completed checkout for the items in this cart, so we have emptied your cart for you.",

		orderInProgress:
			"You are currently checking out in another tab or window. Please close all other tabs and windows before editing the cart.",

		anotherCheckoutInProgress:
			"You are currently checking out in another tab or window. Please close any other checkout tabs or windows before continuing.",

		mustRedoCheckout:
			"Your cart was updated in another tab or window. Please review your cart again before continuing checkout.",

		mustRedoCheckoutPriceMismatch:
			"There was an issue preparing your order. Please close any other checkout tabs or windows and review your cart and address before continuing.",

		startPaypalFail: "Unable to connect to PayPal. Please try again.",

		// Don't think this can get used.
		paypalInfoFieldError:
			"Unable to process PayPal information. Please double check the forms and try again.",

		couponNoLongerValid:
			"Your coupon code is no longer valid. Please enter a different coupon code or continue without a coupon.",

		couponOutOfDate:
			"Your coupon's status has changed since you entered it. Please reenter the coupon and try again.",

		changeSubscriptionTooFarOut:
			"Subscriptions cannot extend beyond 5 years from today's date.",

		changeSubscriptionStudentExists:
			"Your Parent Account already has a subscription with this name. To modify that subscription, go back to the Account page.",

		changeSubscriptionFail:
			"There was an issue changing your subscription. Please try again.",

		cardExpired:
			"Your card is expired. Please update your billing information and try again.",

		changeSubscriptionPriceFail:
			"Some information on this page was out-of-date. We have reloaded your data. Please review your information and try again.",

		changeSubscriptionInvalid:
			"Some information on this page was out-of-date. We have reloaded your data. Please review your information and try again.",

		changeSubscriptionUnknown:
			"Your order might not have been placed successfully.  Please contact us at tech-support@beastacademy.com to resolve this issue.",

		cancelSubscriptionFail:
			"There was an issue canceling your subscription. Please try again.",

		cancelSubscriptionInvalid:
			"Some information on this page was out-of-date. We have reloaded your data. Please review your information and try again.",

		cancelSubscriptionUnknown:
			"Your cancellation might not have been submitted successfully.  Please contact us at tech-support@beastacademy.com to resolve this issue.",

		// Catch-all that we don't use intentionally
		default: "There was an issue performing that action. Please try again.",
	};
};

const getRecurringBillingCopy = function({
	monthly = 0,
	yearly = 0,
	bundle = 0,
} = {}) {
	let agree = `I authorize my payment method to be charged on a recurring basis. I understand that upon renewal I will be billed`;
	if (monthly) {
		agree += ` the monthly fee for ${monthly} Monthly subscription${
			monthly > 1 ? "s" : ""
		} `;
		const moFull = StringUtil.toPrice(dbShop["beast-monthly"].price);
		const moMulti = StringUtil.toPrice(dbShop["beast-monthly"].multiPrice);
		agree += `(currently ${moFull} for the first Monthly subscription and ${moMulti} for each additional subscription)`;
	}
	if (monthly && yearly) {
		agree += " and";
	}
	if (yearly) {
		agree += ` the annual fee for ${yearly} Yearly subscription${
			yearly > 1 ? "s" : ""
		} `;
		const yeFull = StringUtil.toPrice(dbShop["beast-yearly"].price);
		const yeMulti = StringUtil.toPrice(dbShop["beast-yearly"].multiPrice);
		agree += `(currently ${yeFull} for the first Yearly subscription and ${yeMulti} for each additional subscription)`;
	}
	agree += ".";
	if (bundle) {
		agree +=
			" Yearly subscriptions included in a bundle do not automatically renew.";
	}
	agree += " I understand I can turn off recurring billing at any time.";
	return agree;
};

const getSubscriptionsWarning = function(type, styles, opts = {}) {
	const {includeUpgradeText = false} = opts;
	if (type === "parent") {
		return (
			<div>
				{"Manage subscriptions on "}
				<Link className={styles.link} to={URLMake.forAccount()}>
					Account
				</Link>
				{" page"}
			</div>
		);
	} else if (type === "classwallet") {
		const enrollPageLink = URLMake.forEnroll();
		return (
			<div>
				{`Note: Subscription orders ${
					includeUpgradeText ? "and upgrades" : ""
				} cannot be purchased directly through ClassWallet.
					If you are interested in buying a redeemable Yearly Subscription Code, click `}
				<Link to={enrollPageLink} className={styles.warningLink}>
					{"here"}
				</Link>
				{"."}
			</div>
		);
	} else {
		return "You cannot purchase subscriptions with this account.";
	}
};

const getChangeSubscriptionNote = function(subscription) {
	const expDate = moment.utc(subscription.expiresAt).format("MMMM D, YYYY");
	return (
		`Note: This change will take effect at the end of your current ` +
		`${subscription.planType} subscription on ${expDate}.`
	);
};

const getSubscriptionChangeWarning = function(info) {
	if (info.delayedChange) {
		const price = StringUtil.toShortPrice(
			dbShop[`beast-${info.newType}`].price
		);
		const multiPrice = StringUtil.toShortPrice(
			dbShop[`beast-${info.newType}`].multiPrice
		);
		const time = info.newType.substr(0, info.newType.length - 2); //Remove ly

		return (
			`*You will be billed at the ${info.newType} rate (${price}/${time}, ${multiPrice} for each additional student)` +
			` beginning when your current subscription ends on ${info.oldExpiresAt}.`
		);
	} else {
		return `Your subscription's expiration date will be extended to ${info.newExpiresAt}.`;
	}
};

const getCouponExtraCopy = function(applied, remaining) {
	if (applied === "0.00") {
		return `†$${remaining} will be applied to your next automatic payment(s).`;
	} else {
		return `†The remaining $${remaining} from this coupon will be applied to your next automatic payment(s).`;
	}
};

const getParentErrorCopy = function(error) {
	if (error === "studentRegistrationInProgress") {
		return "This step has already been completed. Refresh to complete Student Account setup.";
	} else {
		return "There was an issue. Please try again.";
	}
};

const getTeacherErrorCopy = function(error) {
	let message = "";
	if (error === "E_MISSING_TEACHER_OR_ADMIN_PERMISSIONS") {
		message = "You do not have permission for this action.";
	} else if (error === "E_MISSING_SCHOOL_PERMISSIONS") {
		message = "You do not have permission for this action.";
	} else if (error === "E_NO_SCHOOL_RELATIONS") {
		message = "You must be associated with a school to perform this action.";
	} else if (error === "E_NO_SCHOOL_SPECIFIED") {
		message = "You must be associated with a school to perform this action.";
	}
	return message;
};

const getBeyondBACopy = function(styles) {
	const sharedText = (
		<div>
			<p>
				{`The next step for students who have completed the Beast Academy book series is `}
				<Link
					to={`https://artofproblemsolving.com/store/item/prealgebra`}
					isNewTab={true}
					className={styles.link}
				>
					AoPS Prealgebra
				</Link>
				{`.`}
			</p>
			<p>
				{`Learn about making the transition to AoPS Online in our article, "`}
				<Link
					to={`https://artofproblemsolving.com/news/articles/whats-next-after-beast-academy`}
					isNewTab={true}
					className={styles.link}
				>
					{`What's next after Beast Academy?`}
				</Link>
				{`"`}
			</p>
		</div>
	);
	return {
		resources: (
			<div className={styles.expandableTextContainerContent}>
				{`Ready to move beyond Beast Academy?`}
				<br />
				{sharedText}
			</div>
		),
		bookstore: (
			<div className={styles.expandableTextContainerContent}>{sharedText}</div>
		),
		bookstoreShort: (
			<div>
				{`The next step for students who have completed Beast Academy is `}
				<Link
					to={`https://artofproblemsolving.com/store/item/prealgebra`}
					isNewTab={true}
					className={styles.link}
				>
					AoPS Prealgebra
				</Link>
				{`.`}
				<br />
				<br />
				{`Learn about making the transition in our `}
				<Link
					to={`https://artofproblemsolving.com/news/articles/whats-next-after-beast-academy`}
					isNewTab={true}
					className={styles.link}
				>
					{`"What's next?"`}
				</Link>
				{` article.`}
			</div>
		),
	};
};

const getResourcesCopy = function(styles) {
	return {
		errata: (
			<div>
				<div className={styles.resourcesHeader}>
					Even Math Beasts Make Mistakes
				</div>
				<p>
					Below is a list of errors that have been found in the Beast Academy
					books.
				</p>
				<p>
					Errors noted in <span className={styles.corrected}>light gray</span>{" "}
					text are from previous editions and have been corrected in the most
					recent printing.
				</p>
				<p>
					{"If you find an error that is not currently listed, "}
					<Link
						className={styles.contactLink}
						to={URLMake.forContactReason("books")}
					>
						please click here to let us know.
					</Link>
				</p>
			</div>
		),
		placementtests: (
			<div>
				<div className={styles.resourcesHeader}>
					Placement Tests to Help You Choose Where to Begin
				</div>
				<p>
					We recommend that you choose your student's Beast Academy Level by
					their age:
				</p>
				<ul>
					<li>Students ages 6-8 should begin Beast Academy in Level 1</li>
					<li>Students ages 7-9 should begin Beast Academy in Level 2</li>
					<li>Students ages 8-10 should begin Beast Academy in Level 3</li>
					<li>Students ages 9-12 should begin Beast Academy in Level 4</li>
					<li>Students ages 10-13 should begin Beast Academy in Level 5</li>
				</ul>
				<p>
					You can use the placement tests below to help you choose the right
					level.
				</p>
				<p>
					There are four placement tests for each BA level, one for each unit.
					For example, level 2 includes tests for Beast Academy 2A, 2B, 2C, and
					2D. Each test covers three chapters. For example, 2A covers Chapters
					1-3, 2B covers Chapters 4-6, etc.
				</p>
				<p>
					Students using BA Online have access to every chapter in every level
					and can adjust as needed while using the program.
				</p>
				<p>
					Each test includes instructions for administration and grading, as
					well as complete solutions.
				</p>
			</div>
		),
		printables: (
			<div>
				<div className={styles.resourcesHeader}>
					Printable Extras for Use with Beast Academy
				</div>
				<p>
					The PDFs below offer additional resources you can use with the Beast
					Academy curriculum, including extra practice, games, cards, and other
					materials to help you supplement the series.
				</p>
				<p>
					All of the materials below are mentioned in the Beast Academy Guide
					and Practice books.
				</p>
			</div>
		),
		planning: (
			<div>
				<div className={styles.resourcesHeader}>
					Resources to Help You Plan and Organize BA
				</div>
				<p>
					Use the documents below to help you plan and organize lessons using
					Beast Academy books and online materials.
				</p>
				<p>
					If you are planning to use both the Practice book and BA Online, we
					recommend using one as the primary source of practice and the other as
					a supplement when needed.
				</p>
			</div>
		),
		backgrounds: (
			<div>
				<div className={styles.resourcesHeader}>Custom Virtual Backgrounds</div>
				<p>
					Make your meetings and distance learning experience just a little more
					fantastical with these fun, colorful backgrounds that bring you into
					the world of Beast Academy.
				</p>
			</div>
		),
		characters: {
			alex: {
				img: "alex-errata",
			},
			headmaster: {
				img: "headmaster-chalk",
			},
		},
	};
};

const getTeacherPagesCopy = function() {
	return {
		invalidNumStudents: "Please enter a number of students between 1 and 50.",
		invalidClassName: "Please enter a class name",
		lockedChapter: "This chapter is locked.",
		lockedGrade: "This grade is locked.",
	};
};

const getUnsupportedBrowserCopy = function() {
	return `You are using a web browser not supported by this website. For the optimal Beast Academy experience,
    please update your browser.`;
};

const getReturnPolicy = function(hasNonBundleBooks) {
	const lines = [];
	if (hasNonBundleBooks) {
		lines.push(
			<p key={"return-books"}>
				Return books within 30 days for a refund (minus shipping). Books must be
				returned in new condition at your expense to the address on your
				receipt.
			</p>
		);
	}
	return lines;
};

const getTaxExemptPolicy = function(hasSalesTax, clickHandler) {
	const lines = [];
	const linkClass = infoStyles.link + " " + infoStyles.hasCursor;
	if (hasSalesTax) {
		lines.push(
			<p key={"tax-exempt-order"}>
				{`Click `}
				<span className={linkClass} onClick={clickHandler}>
					here
				</span>
				{` to view sales tax information and tax-exempt ordering.`}{" "}
			</p>
		);
	}
	return lines;
};

const getPolicyModalNotifications = function() {
	return {
		taxation: {
			title: "Sales Tax Policy",
			content: (
				<div>
					<p>
						{`Beast Academy is obligated to charge sales tax in Canada and in the following states: AZ, CA, CO, CT, DC, FL, GA, IL, IN, MA, MD, MI, MN, MO, NC, NJ, NM, NY, OH, PA, SC, TX, VA, WA, and WI. In all other states we do not collect sales tax at this time.`}
					</p>
					<p>
						{`If your organization is tax-exempt and is located in one of the states shown above, then you will need to contact orders@beastacademy.com to place an order. Please include verification of your tax-exempt status such as a copy of your State Exemption Certificate. You cannot place a tax-exempt order in the Beast Academy Online Store.`}
					</p>
					<p>
						{`If you are tax-exempt and are not located in the states mentioned above then you will not be charged sales tax. You can place an order here at `}
						<Link
							to={URLMake.forOffice()}
							isNewTab={true}
							className={infoStyles.link}
						>
							BeastAcademy.com
						</Link>
						{`.`}
					</p>
				</div>
			),
		},
	};
};

const getCancellationPolicy = function(
	subTypeTable,
	forChange = false,
	cannotCancel = false,
	hasCodeItems = false,
	hasGiftItems = false,
	subChangeType,
	isClassWallet = false
) {
	const lines = [];

	if (hasCodeItems || hasGiftItems) {
		lines.push(
			isClassWallet ? (
				<p key={"code-cancellation-classwallet"}>
					All 1-year subscription code sales are final and cannot be cancelled
					or modified after purchase.
				</p>
			) : (
				<p key={"code-cancellation"}>
					All subscription code sales, including Gift code sales, are final and
					cannot be cancelled or modified after purchase.
				</p>
			)
		);
	}
	if (cannotCancel) {
		lines.push(
			<p key={"cannot-cancel"}>
				Subscriptions that are past the initial 14-day cancellation period
				cannot be canceled. All sales are final at the time of billing.
			</p>
		);
		return lines;
	}

	let type = "Monthly or Yearly";
	if (subTypeTable.monthly && !subTypeTable.yearly) {
		type = "Monthly";
	} else if (subTypeTable.yearly && !subTypeTable.monthly) {
		type = "Yearly";
	}
	if ((subTypeTable.monthly || subTypeTable.yearly) && !subTypeTable.bundle) {
		lines.push(
			<p key={"cancel-subscriptions"}>
				Cancel within 14 days for a full refund of the lowest priced{" "}
				{type.toLowerCase()} subscription in your account.
			</p>
		);
	} else if (subTypeTable.monthly || subTypeTable.yearly) {
		lines.push(
			<p key={"cancel-subscriptions"}>
				<b>{type} subscriptions:</b> Cancel within 14 days for a full refund,
				starting with discounted subscriptions.
			</p>
		);
	}
	if (subTypeTable.bundle) {
		lines.push(
			isClassWallet ? (
				<p key={"cancel-bundles-classwallet"}>
					You may return the full book set within 30 days of purchase for a full
					refund, excluding shipping costs. If returning books that are part of
					a Bundle then you will be refunded the difference between the cost of
					the Bundle and the cost of a standard 1-year subscription code. We do
					not accept partial returns of book sets that were purchased as part of
					a Bundle. Return shipping is the responsibility of the customer.
					Please return your books to the address on the Sales Receipt.
				</p>
			) : (
				<p key={"cancel-bundles"}>
					<b>Bundles:</b> Cancel within 30 days of initial purchase for a full
					refund (minus shipping). Books must be returned in new condition at
					your expense to the address on your receipt. We don't accept partial
					book returns. Your refund will be the bundle price minus the value of
					any items you keep.
				</p>
			)
		);
	}

	return lines;
};

const getCodeTermsAndConditions = function(
	hasCodeItems,
	hasGiftItems,
	isClassWallet = false
) {
	if (!(hasCodeItems || hasGiftItems)) {
		return;
	}
	return [
		isClassWallet ? (
			<p key={"code-terms-and-conditions-classwallet"}>
				A 1-year subscription code Bundle cannot be combined with other offers.
				1-year subscription codes are not for business use. Email
				orders@beastacademy.com with questions.
			</p>
		) : (
			<p key={"code-terms-and-conditions"}>
				Subscription codes, including Gift codes, cannot be combined with other
				offers. Subscription codes are not for business use. Email
				orders@beastacademy.com with questions.
			</p>
		),
	];
};

const getCancelRefundCopy = function(canceledAt, refundedAt, usedB2BBulkCode) {
	if (refundedAt) {
		return (
			<span>
				Canceled on {canceledAt}.<br />
				Your refund was processed on {refundedAt}.
			</span>
		);
	} else {
		return (
			<span>
				Canceled on {canceledAt}.<br />
				{usedB2BBulkCode
					? ""
					: "Your refund will be processed within 7-10 business days of cancellation."}
			</span>
		);
	}
};

// subTypeTable is an object with keys "monthly", "yearly", "bundle"
// and values with the # of subscriptions of that type.
const getRenewalPolicy = function(
	subTypeTable,
	hasCodeItems,
	isClassWallet = false
) {
	const lines = [];
	// inside a CW session, add the renewal policy if they have a code or a code bundle
	if (isClassWallet && (hasCodeItems || subTypeTable.bundle)) {
		lines.push(
			<p key="renewal-classwallet">
				Your 1-year subscription will not renew automatically. You can redeem
				another 1-year subscription code to add another year to a subscription
				that was first activated by a code.
			</p>
		);
		return lines;
	}

	if (subTypeTable.monthly || subTypeTable.yearly) {
		let type = "Monthly or Yearly";
		if (subTypeTable.monthly && !subTypeTable.yearly) {
			type = "Monthly";
		} else if (subTypeTable.yearly && !subTypeTable.monthly) {
			type = "Yearly";
		}
		if (subTypeTable.bundle) {
			lines.push(
				<p key="renewal-subscriptions">
					{type} subscriptions renew automatically. Bundle subscriptions don't
					auto-renew. Manage renewals on your Account page.
				</p>
			);
		} else {
			lines.push(
				<p key="renewal-subscriptions">
					{type} subscriptions renew automatically. Manage renewals on your
					Account page.
				</p>
			);
		}
	} else if (subTypeTable.bundle) {
		lines.push(
			<p key="renewal-bundle">
				Bundle subscriptions don't auto-renew. Renew anytime on your Account
				page.
			</p>
		);
	}

	return lines;
};

const getCalendarInfoCopy = function() {
	return (
		<div>
			The calendar shows the minutes played for each day. This only includes
			time spent in the Classroom (playing lessons), Library (reading book
			sections), Theater (watching instructional videos), Puzzle Lab (solving
			puzzles), and Beast Builder (building a monster avatar).
			<br />
			<br />
			Click any day to view a breakdown of time spent in these areas, including
			a complete list of Lessons Played, Sections Read, Videos Watched, and
			Puzzles Played.
			<br />
			<br />
			Note that the total in the stars column only counts new stars—ones that
			were not earned on a previous attempt.
			<br />
			<br />
			Note that excessive idle time (elapsed time when no mouse, touch, or
			keyboard input is detected) is not counted towards these totals.
		</div>
	);
};

const forUnregisteredStudentReport = function(displayName) {
	return `${displayName}'s account isn't set up yet. Click here to get started.`;
};

const getParentStudentRegistrationCopy = function(studentData, styles) {
	const {displayName} = studentData;
	return {
		welcome: {
			content: (
				<div className={styles.step}>
					<div className={styles.stepTitle}>
						{"Welcome to the Reports page!"}
					</div>
					<div className={styles.stretch}>
						<div className={styles.stretchImgContainer}>
							<img
								className={styles.headmaster}
								src={
									global.BASE_URL +
									"assets/images/office/characters/headmaster-computer.svg"
								}
								alt="BA Headmaster"
							/>
						</div>
					</div>
					<div className={styles.detailText}>
						{`This is where you'll see a snapshot of ${displayName}'s progress.`}
					</div>
					<div className={styles.detailText}>
						{`Before ${displayName} can start playing, you'll need to set up their account.`}
					</div>
				</div>
			),
			buttonText: "Get Started",
			below: (
				<div className={styles.belowText}>
					<Link
						to={KB_URLS.SETUP_STUDENT_ACCOUNT}
						isNewTab={true}
						className={styles.link}
					>
						{"Learn more about how to setup your student's account."}
					</Link>
				</div>
			),
		},
		secondaryWelcome: {
			content: (
				<div className={styles.step}>
					<div className={styles.stepTitle}>
						Check out {displayName}'s progress!
					</div>
					<div className={styles.stretch}>
						<div className={styles.stretchImgContainer}>
							<img
								className={styles.headmaster}
								src={
									global.BASE_URL +
									"assets/images/office/characters/headmaster-chalk.svg"
								}
								alt="BA Headmaster"
							/>
						</div>
					</div>
					<div className={styles.detailText}>
						{displayName} has been doing amazing work in Beast Academy so far!
					</div>
					<div className={styles.detailText}>
						To personalize your snapshot, let us know how you're using BAO
						first.
					</div>
				</div>
			),
			buttonText: `View ${displayName}'s Progress`,
		},
		steps: {
			displayName: {
				name: "Display Name",
				description: "Name your student",
				text:
					"What should we call your student? This name will be used throughout Beast Academy.",
			},
			customerSegment: {
				name: "Customer Segment",
				description: "Tell us how you will use BA Online",
				text:
					"Choose each option that best describes how you will use Beast Academy.",
				questions: [
					{
						A: "We will use Beast Academy as our primary math curriculum",
						B: "We will use Beast Academy as a supplemental math curriculum",
					},
					{
						A: `I prefer to be very involved with ${displayName}'s learning`,
						B: `I encourage ${displayName} to learn independently`,
					},
					{
						A: `I hope ${displayName} is in the top of their class`,
						B: `${displayName} does not need to be in the top of their class`,
					},
				],
			},
			baLevel: {
				name: "BA Level",
				description: `Choose the right BA Level for ${displayName}.`,
				text: (
					<div className={styles.stepText}>
						{
							"Choosing the right starting point for your student can help them avoid early frustrations."
						}
						<br />
						{
							"Select your student's age to help us recommend a BA Level to start with."
						}
					</div>
				),
				baLevelDropdownPlaceholderText: (
					<div className={styles.dropdownPlaceholderText}>
						{"Please select an age first."}
					</div>
				),
				below: (
					<div className={styles.belowText}>
						{"You can change these later on your Parent Account page."}
					</div>
				),
			},
			lockScheme: {
				name: "Lock Scheme",
				description: `Choose how lessons unlock for ${displayName}.`,
				below: (
					<div className={styles.belowText}>
						{"You can change these later on your Parent Account page."}
					</div>
				),
			},
			username: {
				name: "Username",
				description: `Have ${displayName} choose a username.`,
				below: (
					<div className={styles.belowText + " " + styles.italicRed}>
						{`You `}
						<b>cannot</b>
						{` change ${displayName}'s username once it is selected.`}
					</div>
				),
			},
			password: {
				name: "Password",
				description: `Have ${displayName} choose a password.`,
				below: (
					<div className={styles.belowText}>
						{`You can update ${displayName}'s password on your Account page.`}
					</div>
				),
			},
		},
		needHelp: (
			<Link
				to={URLMake.forParentSupport("getstarted")}
				isNewTab={true}
				className={styles.link}
			>
				{`Need help? Check out our Help Site.`}
			</Link>
		),
		final: {
			top: (
				<div className={styles.stepTitle}>
					{`${displayName}'s Student Account is ready to go!`}
				</div>
			),
			bottom: (
				<div className={styles.finalBottom}>
					<div className={styles.finalText}>
						{`When ${displayName} is ready to start, use the `}
						<span className={styles.play}>{"Play"}</span>
						{" dropdown in the top-right corner to sign in and get started."}
						<span className={styles.mobileOnly}>
							The Play button only appears on screens that are wide enough for
							student play, including any desktop, laptop, or tablet in
							landscape mode.
						</span>
					</div>
					<div className={styles.finalText}>
						{`Once ${displayName} starts playing, their progress and activity will be displayed on this page.`}
					</div>
					<div className={styles.finalText}>
						<Link
							to={URLMake.forParentSupport("play")}
							isNewTab={true}
							className={styles.link}
						>
							{
								"Learn more about navigating Beast Academy Online on our Help Site."
							}
						</Link>
					</div>
				</div>
			),
		},
	};
};

const getLevelExplanationCopy = function(styles) {
	return (
		<div>
			{`Because Beast Academy is such a challenging curriculum that teaches material in depth, we generally recommend
        that students start at Level 3 if they are in 3rd or 4th grade and Level 4 if they are in 5th grade, even if they have
        already learned those topics in school.  An advanced 5th grader might start later in the curriculum
        if they are especially far ahead, but they would still deepen their understanding and problem-solving skills
        by starting earlier. 5 is a good starting point for any students in 6th and 7th grade who have not taken
        Prealgebra yet. Try our `}
			<Link
				to={URLMake.forResources("placementtests")}
				isNewTab={true}
				className={styles.link}
			>
				placement tests
			</Link>
			{` to help determine which level to start with.`}
		</div>
	);
};

const getChooseSubscriptionsCopy = function(opts = {}) {
	return {
		monthly: {
			tagline:
				"Unlimited access to Beast Academy Online with no long\u2011term commitment.",
		},
		yearly: {
			tagline: `Just $${opts.yearlyPricePerMonth}/month when you sign up for a year.`,
			monthlyUpgrade: `Apply your most recent Monthly payment to upgrade to a Yearly subscription for just ${StringUtil.toPrice(
				opts.upgradePrice
			)}. This will extend your subscription until ${moment(
				opts.newExpiresAt
			).format("LL")}.`,
		},
		bundle: {
			tagline:
				"Save over $50 when you bundle a 1\u2011year subscription to BA Online and 1 year of books.",
			yearlyUpgrade: `Upgrade to a Bundle subscription by ${moment(
				opts.upgradeUntil
			).format("LL")} to add a full level of Beast Academy books (${
				opts.numBooks
			} books) for ${StringUtil.toPrice(opts.upgradePrice)} (normally $${
				opts.bundleBookPrice
			}).`,
			monthlyUpgrade: `Apply your most recent Monthly payment to upgrade to a Bundle subscription. This will add a full level of Beast Academy books (${
				opts.numBooks
			} books) and extend your subscription until ${moment(
				opts.newExpiresAt
			).format("LL")} for ${StringUtil.toPrice(opts.upgradePrice)} (normally $${
				opts.bundlePrice
			}).`,
		},
		disabledTagline: "This is your current subscription.",
	};
};

const getChooseSubscriptionBlockingMessages = function() {
	return {
		needsPlanAndDisplayName: "Choose a name and subscription type to continue.",
		needsPlanType: "Choose a subscription type to continue.",
		needsDisplayName: "Choose a student nickname to continue.",
		needsBundleGrades: "Select bundle(s) to continue.",
	};
};

const getDisplayNameCopy = function() {
	return {
		title: "Student Name",
		info: `Only you and your student will see this name, and you can change it later. It is used on parent pages to identify your student's account and for in-game messages to your student like "Great work, Jamie!" Your student will get to pick their own username and password once they are enrolled.`,
		placeholder: "Student name or nickname (e.g. Jamie)",
		placeholderShort: "Student name",
	};
};

const getBundleSelectionCopy = function() {
	const styles = BundleSelectStyles;
	const dash = "\u2011";
	return (
		<div>
			<p>
				Each bundle includes a full year of Beast Academy books and a 1{dash}
				year subscription to Beast Academy Online.
			</p>
			<p className={styles.levelP}>
				<span className={styles.subtitle}>BA 1:</span>
				Includes 1A
				{dash}
				1D combined Guide + Practice books and a 1{dash}
				year subscription to Beast Academy Online*.
			</p>
			<p className={styles.levelP}>
				<span className={styles.subtitle}>BA 2:</span>
				Includes 2A
				{dash}
				2D Guide and Practice books and a 1{dash}
				year subscription to Beast Academy Online*.
			</p>
			<p className={styles.levelP}>
				<span className={styles.subtitle}>BA 3:</span>
				Includes 3A
				{dash}
				3D Guide and Practice books and a 1{dash}
				year subscription to Beast Academy Online*.
			</p>
			<p className={styles.levelP}>
				<span className={styles.subtitle}>BA 4:</span>
				Includes 4A
				{dash}
				4D Guide and Practice books and a 1{dash}
				year subscription to Beast Academy Online*.
			</p>
			<p className={styles.levelP}>
				<span className={styles.subtitle}>BA 5:</span>
				Includes 5A
				{dash}
				5D Guide and Practice books and a 1{dash}
				year subscription to Beast Academy Online*.
			</p>
			<p>
				*A subscription to BA Online includes access to the full online
				curriculum and digital Guide books for grades 1, 2, 3, 4, and 5.
			</p>
			<p>
				{"Try our "}
				<Link
					to={URLMake.forResources("placementtests")}
					isNewTab={true}
					noFocus={true}
					className={styles.link}
				>
					placement tests
				</Link>
				{" to help determine which books to start with."}
			</p>
		</div>
	);
};

const getResetCopy = function(displayName) {
	return {
		reset: {
			title: displayName
				? `Change Password for ${displayName}`
				: "Change Your Password",
		},
		confirmation: {
			title: displayName
				? `Password for ${displayName} has been changed.`
				: `Your password has been changed.`,
		},
		oldPassword: "Enter current password",
		newPassword: "Enter new password",
		newPasswordRepeat: "Enter new password again",
	};
};

// This is for parent email changes, see school copytable for teacher
// errors.
const getChangeEmailCopy = function(email) {
	return {
		title: "Change Parent Account Email",
		newEmail: "Enter new email",
		confirmation: (
			<span>
				A confirmation has been sent to {email}.<br />
				You must confirm your new email within 24 hours to use it to sign in and
				to receive updates.
			</span>
		),
	};
};

// This is for parent email changes, see school copytable for teacher
// errors.
const forChangeEmailError = function(code) {
	if (code === "E_EMAIL_EXISTS") {
		return "This account already exists.";
	} else if (code === "E_NEW_EMAIL_MISSING") {
		return "Please enter a new email.";
	} else if (code === "E_NEW_EMAIL_REPEAT_MISSING") {
		return "Please repeat the new email in the second box.";
	} else if (code === "E_EMAIL_MISMATCH") {
		return "Emails do not match.";
	} else if (code === "E_NO_CHANGE") {
		return "This is already your Parent Account email.";
	} else if (code === "E_INVALID_NEW_EMAIL") {
		return "This email is invalid.";
	} else if (code === "E_RATE_LIMIT") {
		return "Too many requests of this type. Try again later.";
	} else if (code === "E_SSO_EMAIL_CHANGE_NOT_ALLOWED") {
		return "Email cannot be changed for accounts created with Google or another sign-in provider.";
	} else {
		return "Request cannot be completed. Try again later.";
	}
};

const getAccountOptions = function({
	type,
	styles = {},
	parentDefault,
	scope,
	scopeChildren,
	isSingleSchool,
	isParent,
	isInitialSetup,
	studentName,
	baLevel,
	username,
	avatarModel,
}) {
	const otherText =
		scope && scope !== "system" && !isSingleSchool
			? `This will not affect any other ${scope}.`
			: "";
	let defaultText = scope
		? ` This will be the default for any new ${scopeChildren} in this ${scope}.`
		: "";
	if (scope === "class") {
		defaultText = " This will be the setting for all students in this class.";
	}
	const makeOptions = (keys, data, alwaysLeftAligned) => {
		const descriptionStyle = alwaysLeftAligned
			? infoStyles.mInfoLeft
			: infoStyles.mInfo;
		return keys.map(k => {
			return (
				<div className={infoStyles.mOption} key={k}>
					<div className={infoStyles.mName}>
						{data[k].label}
						<span className={infoStyles.nameColon}>{":"}</span>
					</div>
					<div className={descriptionStyle}>{data[k].description}</div>
				</div>
			);
		});
	};
	const parentDefaultText = " (Default)";
	if (type === "displayedGrade") {
		const schoolGradeDesc = extra => (
			<div className={infoStyles.mDesc}>
				Select the grade level (Kindergarten through Grade 8) that you would
				like associated with this class. This is used for sorting and filtering
				but does not affect what materials students have access to in BA Online.
				<br />
				<br />
				To affect what materials students have access to, select a BA Level for
				the class. {extra}
			</div>
		);
		const allowedGrades = ALLOWED_CLASS_GRADES;
		const gradeOpts = allowedGrades.map(g => ({
			key: g,
			label: getDisplayedGradeLabel(g),
		}));
		return {
			title: "Select a Grade",
			infoTitle: "Grade",
			description: schoolGradeDesc(),
			options: gradeOpts,
			info: (
				<div>
					{schoolGradeDesc(
						"Classes new to BA Online should usually begin in a BA level that is at least one less than the class grade level."
					)}
				</div>
			),
			opts: gradeOpts,
		};
	} else if (type === "schoolGrade") {
		const schoolGradeDesc = (
			<div className={infoStyles.mDesc}>
				Select the BA Level for this class. This will set the default level
				where all students in this class begin in the BA Online classroom.
				<br />
				<br />
				Advanced classes and students may begin at a BA level matching their
				grade, however,{" "}
				<b>
					we recommend that students new to Beast Academy always begin in a
					level that is at least 1 less than their current math grade level in
					school
				</b>
				.
			</div>
		);
		const gradeOpts = {
			BA1: {
				key: 1,
				label: "BA1",
				description: "Recommended for students in grade 2.",
			},
			BA2: {
				key: 2,
				label: "BA2",
				description: "Recommended for students in grade 3.",
			},
			BA3: {
				key: 3,
				label: "BA3",
				description: "Recommended for students in grades 4.",
			},
			BA4: {
				key: 4,
				label: "BA4",
				description: "Recommended for students in grades 5-6.",
			},
			BA5: {
				key: 5,
				label: "BA5",
				description: "Recommended for students in grades 6-7.",
			},
		};
		return {
			title: "Select a BA Level",
			infoTitle: "BA Level",
			description: schoolGradeDesc,
			options: [
				gradeOpts.BA1,
				gradeOpts.BA2,
				gradeOpts.BA3,
				gradeOpts.BA4,
				gradeOpts.BA5,
			],
			info: (
				<div>
					{schoolGradeDesc}
					{makeOptions(["BA1", "BA2", "BA3", "BA4", "BA5"], gradeOpts)}
				</div>
			),
			opts: gradeOpts,
		};
	} else if (type === "grade") {
		const gradeDesc = (
			<div className={infoStyles.mDesc}>
				Select a level where you would like your student to begin using BA
				Online.
				<p>
					All subscriptions include access to all of the available grade levels.
				</p>
				Because Beast Academy is such a challenging curriculum, we recommend
				students begin BA Online with a grade level they have recently
				completed.
			</div>
		);
		const gradeOpts = {
			BA1: {
				key: 1,
				label: "BA Level 1",
				description:
					"Recommended for students who have completed a standard 1st grade curriculum.",
			},
			BA2: {
				key: 2,
				label: "BA Level 2",
				description:
					"Recommended for students who have completed a standard 2nd grade curriculum.",
			},
			BA3: {
				key: 3,
				label: "BA Level 3",
				description:
					"Recommended for students who have completed a standard 3rd grade curriculum.",
			},
			BA4: {
				key: 4,
				label: "BA Level 4",
				description:
					"Recommended for students who have completed a standard 4th grade curriculum.",
			},
			BA5: {
				key: 5,
				label: "BA Level 5",
				description:
					"Recommended for students who have completed a standard 5th grade curriculum.",
			},
		};
		const sortedGradeOpts = Object.entries(gradeOpts)
			.sort(([opt1Key], [opt2Key]) => {
				if (opt1Key < opt2Key) {
					return -1;
				} else if (opt1Key === opt2Key) {
					return 0;
				} else {
					return 1;
				}
			})
			.map(([, value]) => value);
		return {
			title: "Select BA Level",
			infoTitle: "BA Level",
			description: gradeDesc,
			options: sortedGradeOpts,
			info: (
				<div>
					{gradeDesc}
					{makeOptions(["BA1", "BA2", "BA3", "BA4", "BA5"], gradeOpts)}
					<div className={infoStyles.mDesc}>
						<p>
							You can also use our book{" "}
							<Link
								className={infoStyles.link}
								to={URLMake.forResources("placementtests")}
								isNewTab={true}
							>
								Placement Tests
							</Link>{" "}
							to help you find the right level.
						</p>
					</div>
				</div>
			),
			opts: gradeOpts,
		};
	} else if (type === "age") {
		return [
			{
				key: "under6",
				label: "Under 6",
				recommendedLevel: 1,
				description:
					"BA 1 is recommended for students ages 6-8, but can be used by very advanced younger students.",
			},
			{
				key: "6",
				label: "6",
				recommendedLevel: 1,
				description: "BA 1 is recommended for students ages 6-8.",
			},
			{
				key: "7",
				label: "7",
				recommendedLevel: 1,
				description: "BA 1 is recommended for students ages 6-8.",
			},
			{
				key: "8",
				label: "8",
				recommendedLevel: 2,
				description: "BA 2 is recommended for students ages 7-9.",
			},
			{
				key: "9",
				label: "9",
				recommendedLevel: 3,
				description: "BA 3 is recommended for students ages 9-10.",
			},
			{
				key: "10",
				label: "10",
				recommendedLevel: 4,
				description: "BA 4 is recommended for students ages 10-12.",
			},
			{
				key: "11",
				label: "11",
				recommendedLevel: 5,
				description: "BA 5 is recommended for students ages 11-13.",
			},
			{
				key: "over11",
				label: "Over 11",
				recommendedLevel: 5,
				description: "BA 5 is recommended for students ages 11-13.",
			},
		];
	} else if (type === "lockSettings") {
		const linkFunc = isParent
			? URLMake.forParentSupport
			: URLMake.forSchoolSupport;
		const warningText = (
			<p>
				<b>
					{" "}
					Changing the lock scheme will not override any manual locks you have
					set.{" "}
				</b>{" "}
				<Link
					to={linkFunc("reports", "locks")}
					isNewTab={true}
					className={infoStyles.link}
					noFocus={true}
				>
					Read more about play settings on our Help Site
				</Link>
				{"."}
			</p>
		);
		const lockDesc = scope ? (
			<div className={infoStyles.mDesc}>
				{`Lock schemes determine what lessons are unlocked for your students. ${defaultText} ${otherText}`}
				{warningText}
			</div>
		) : (
			<div className={infoStyles.mDesc}>
				Lock schemes determine what lessons are unlocked for your student.
				{warningText}
			</div>
		);
		const lockSchemes = {
			default: {
				key: "default",
				label:
					"Sequential" + (parentDefault === "default" ? parentDefaultText : ""),
				description: (
					<span>
						Unlocks the first lesson in each chapter up to the start of a
						student's current BA Level. They will play and unlock future lessons
						in order.
						<br />
						<b className={styles.detailText}>
							{isParent
								? "(Recommended for students working independently.)"
								: "(For students working independently.)"}
						</b>
					</span>
				),
				shortDescription: (
					<span>
						{studentName} will start in BA {baLevel} Chapter 1 and unlock
						lessons with progress. This lock scheme also unlocks previous
						chapters.
						<br />
						<b className={styles.detailText}>
							(Recommended for students working independently.)
						</b>
					</span>
				),
			},
			chapters: {
				key: "chapters",
				label:
					"All Chapters" +
					(parentDefault === "chapters" ? parentDefaultText : ""),
				description: (
					<span>
						Unlocks the first lesson in every chapter so a student can start in
						any chapter, but must play the chapter lessons in order.
						<br />
						<b className={styles.detailText}>
							{isParent
								? "(Requires supervision from a parent or teacher.)"
								: "(Offers more flexibility.)"}
						</b>
					</span>
				),
				shortDescription: (
					<span>
						Unlocks the first lesson in every chapter. {studentName} can start
						in any chapter.
						<br />
						<b className={styles.detailText}>
							(Requires supervision from a parent or teacher.)
						</b>
					</span>
				),
			},
			all: {
				key: "all",
				label: "Free Play" + (parentDefault === "all" ? parentDefaultText : ""),
				description: (
					<span>
						Every lesson is unlocked. A student will be able to skip around and
						play any lesson.
						<br />
						<b className={styles.detailText}>
							{isParent
								? "(Requires close guidance from a parent or teacher.)"
								: "(Requires close guidance.)"}
						</b>
					</span>
				),
				shortDescription: (
					<span>
						Unlocks every lesson and lets {studentName} skip around.
						<br />
						<b className={styles.detailText}>
							(Requires close guidance from a parent or teacher.)
						</b>
					</span>
				),
				checkboxTexts: {
					test:
						"Unlock all chapter tests with Free Play. (Normally, a student will unlock a chapter test by completing all but four of the lessons in that chapter.)",
					lab:
						"Unlock the Puzzle Lab with Free Play. (Normally, a student will unlock the Puzzle lab when they reach XP Level 10.)",
				},
			},
		};
		const options = ["default", "chapters"];
		// Show free play option on initial account setup
		options.push("all");
		return {
			title: "Select Lock Scheme",
			infoTitle: "Lock Scheme",
			description: lockDesc,
			options: options.map(o => lockSchemes[o]),
			info: (
				<div>
					{lockDesc}
					{makeOptions(options, lockSchemes, true)}
				</div>
			),
			opts: lockSchemes,
		};
	} else if (type === "updates") {
		return {
			info: (
				<span>
					<p>
						Turn on Email Updates to receive a weekly email every Sunday morning
						that summarizes the work your student has been doing in Beast
						Academy. We also send updates to alert you of milestones and
						achievements, as well as potential problem areas and ways you can
						help.
					</p>
				</span>
			),
			infoTitle: "Email Updates",
		};
	} else if (type === "beast") {
		return {
			info: (
				<span>
					<p>Beast Builder lets students create their own monster avatars.</p>
				</span>
			),
			infoTitle: "Beast Builder Access",
		};
	} else if (type === "leaderboards") {
		return {
			info: (
				<div className={infoStyles.mDesc}>
					<p>
						{`Turn on Leaderboards to allow your student to view and participate in the Beast Academy Leaderboards. Only your student’s
						username (${username}) and avatar (below) will appear on the Leaderboards alongside their stats like trophies and XP earned`}
						.
					</p>
					<p>
						<b>
							Students cannot communicate and will only see statistics, avatars,
							and usernames of other users.
						</b>
					</p>
					<p>
						Turn this option off if you would prefer not to have your student
						view or participate in the Beast Academy leaderboards.
					</p>
					<div className={infoStyles.descList}>
						<Avatar
							hasSurround={true}
							className={infoStyles.avatar}
							avatar={avatarModel}
						/>
					</div>
				</div>
			),
			infoTitle: "Leaderboards",
		};
	} else if (type === "updatesSettings") {
		return {
			title: "Weekly Email Updates",
			description:
				"Weekly email updates will be sent every Sunday to the email addresses listed below.",
			error: "Please enter a valid email",
		};
	} else if (type === "fixedSets") {
		const setOrderDesc = (
			<div className={infoStyles.mDesc}>
				{`Most lessons in Beast Academy Online have at least three sets of problems. You can choose the way problem sets are assigned${
					scope ? ` in this ${scope}` : ""
				}.${defaultText} ${otherText}`}
			</div>
		);
		const setOrderOpts = {
			on: {
				key: "on",
				label:
					"Fixed Order" + (parentDefault === "on" ? parentDefaultText : ""),
				description:
					"All students in this class will see problem sets in the same order as their classmates (recommended).",
			},
			off: {
				key: "off",
				label: "Random" + (parentDefault === "off" ? parentDefaultText : ""),
				description:
					"Problem sets will be assigned at random to individual students.",
			},
		};
		return {
			title: "Problem Sets",
			infoTitle: "Problem Sets",
			description: setOrderDesc,
			options: [setOrderOpts.on, setOrderOpts.off],
			info: (
				<div>
					{setOrderDesc}
					{makeOptions(["on", "off"], setOrderOpts)}
				</div>
			),
			opts: setOrderOpts,
		};
	}
};

const getAccountPlanCopy = function() {
	const monthlyPrice = StringUtil.toPrice(dbShop["beast-monthly"].price);
	const monthlyPriceDisc = StringUtil.toPrice(
		dbShop["beast-monthly"].multiPrice
	);
	const yearlyPrice = StringUtil.toPrice(dbShop["beast-yearly"].price);
	const yearlyPriceDisc = StringUtil.toPrice(dbShop["beast-yearly"].multiPrice);
	const bundlePrice = StringUtil.toPrice(
		OpsCart.calculateBundlePrice("bundle-grade-3").total
	);
	return {
		bundleTitle: "Bundle",
		bundle: (
			<p>
				Bundles are {bundlePrice} each and include a Yearly subscription to BA
				Online as well as a full grade level of Beast Academy Guide and Practice
				books.
			</p>
		),
		monthlyTitle: "Monthly Plan",
		monthly:
			`Monthly subscriptions are ${monthlyPrice}/month and ` +
			`${monthlyPriceDisc}/month for each additional student (up to 6 total).`,
		yearlyTitle: "Yearly Plan",
		yearly:
			`Yearly subscriptions are ${yearlyPrice}/year and ` +
			`${yearlyPriceDisc}/year for each additional student (up to 6 total).`,
	};
};

const getAcceptTermsCopy = function(styles) {
	const linkProps = {className: styles.link, noFocus: true};
	return (
		<span>
			I agree to the Beast Academy{" "}
			<Link to={URLMake.forTerms()} isNewTab={true} {...linkProps}>
				Terms & Conditions
			</Link>{" "}
			and{" "}
			<Link to={URLMake.forPrivacy()} isNewTab={true} {...linkProps}>
				Privacy Policy
			</Link>
			.
		</span>
	);
};

const getAcceptCoppaCopy = function() {
	return "I agree that I am the parent or legal guardian or authorized school official of any student or students under the age of 16 who are registered through this account, and I provide consent for said students to use this website.";
};

const getRenewConfirmCopy = function(expiration) {
	return `Are you sure you want to turn off auto-renew? Your student will no longer be able to play after ${expiration}.`;
};

const getCardWarningCopy = function() {
	return (
		"Changing the payment method will also " +
		"update the card used for billing any future payments."
	);
};

const getClassWalletSubscriptionCopy = function() {
	return (
		"Note: Subscription orders cannot be purchased " +
		"through ClassWallet. Proceeding will use your " +
		"billing information on file."
	);
};

const getBundleCancelCopy = function(
	styles,
	student,
	isCancelingBooks,
	isCancelingOnline,
	hasPendingBookDeferral = false
) {
	const {subscription} = student;
	const name = student.displayName;
	const messageEl = (
		<div>
			Which part of your Bundle would you like to cancel?
			<br />
			(Choose all that apply.)
		</div>
	);
	const linkEl = (
		<Link
			className={styles.link}
			to={URLMake.forFAQ(
				"orders",
				"what-is-the-refund-policy-for-ba-online-bundles"
			)}
			isNewTab={true}
			noFocus={true}
		>
			here
		</Link>
	);
	let refund;
	let reminderEl = null;
	const addressEl = (
		<div>
			<p>
				You may return your <b>full set of books</b> to the address below.
				Return shipping is the responsibility of the customer. Please enclose a
				copy of the Sales Receipt with your return. Please keep a copy of your
				return shipping receipt.
			</p>
			<p className={styles.address}>
				Art of Problem Solving
				<br />
				15330 Avenue of Science
				<br />
				San Diego, CA 92128
			</p>
		</div>
	);
	if (isCancelingBooks && isCancelingOnline) {
		refund = subscription.completeRefund;
		const calculationEl = refund.isHard ? (
			<div>
				<p>
					*Your refund will be processed within 10-15 business days of receipt
					of your books in retail condition.
				</p>
				<p>Please review our refund policy {linkEl}.</p>
			</div>
		) : (
			<div>
				<p>
					*Your refund of ${refund.totalPricePaid} plus applicable tax will be
					processed within 10-15 business days of receipt of your books in
					retail condition.
				</p>
			</div>
		);
		reminderEl = hasPendingBookDeferral ? (
			<div>
				<p>{calculationEl} Your refund will be processed within 10-15 days.</p>
			</div>
		) : (
			<div>
				{calculationEl}
				{addressEl}
			</div>
		);
	} else if (isCancelingBooks) {
		refund = subscription.booksOnlyRefund;
		const expiresAt = moment(subscription.expiresAt);
		const yearAndAHalfFromNow = moment().add(1.5, "years");
		// This modal can only appear if a bundle was created within the last 30 days.
		// That means that we can detect whether it's a multi-year bundle by whether
		// it expires beyond 1.5 years from now.
		const isMultiYearBundle = expiresAt.isAfter(yearAndAHalfFromNow);
		if (!refund.isHard && isMultiYearBundle) {
			reminderEl = hasPendingBookDeferral ? (
				<div>
					<p>
						*Your refund of ${refund.totalRefund} will be processed within 10-15
						days.
					</p>
				</div>
			) : (
				<div>
					<p>
						*Your refund of ${refund.totalRefund} will be processed within 10-15
						business days of receipt of your books in retail condition.
					</p>
					{addressEl}
				</div>
			);
		} else {
			const nonRefundAmount = Number.isInteger(
				refund.totalPricePaid - refund.totalRefund
			)
				? refund.totalPricePaid - refund.totalRefund
				: (refund.totalPricePaid - refund.totalRefund).toFixed(2);
			const calculationEl = refund.isHard ? (
				<span>Please review our refund policy {linkEl}.</span>
			) : (
				<span>
					Since you are keeping the Online portion of your Bundle, the book
					refund will be ${refund.totalPricePaid}&nbsp;-&nbsp;$
					{nonRefundAmount}&nbsp;=&nbsp;$
					{refund.totalRefund} plus taxes and shipping if applicable.
				</span>
			);
			reminderEl = hasPendingBookDeferral ? (
				<div>
					<p>
						{calculationEl} Your refund will be processed within 10-15 days.
					</p>
				</div>
			) : (
				<div>
					<p>
						*You must return the books in retail condition to receive a refund.{" "}
						{calculationEl} Your refund will be processed within 10-15 business
						days of receipt of your books in retail condition.
					</p>
					{addressEl}
				</div>
			);
		}
	} else if (isCancelingOnline) {
		refund = subscription.onlineOnlyRefund;
		const nonRefundAmount = Number.isInteger(
			refund.totalPricePaid - refund.subscriptionRefundTotal
		)
			? refund.totalPricePaid - refund.subscriptionRefundTotal
			: (refund.totalPricePaid - refund.subscriptionRefundTotal).toFixed(2);
		const calculationEl = refund.isHard ? (
			<span>Please review our refund policy {linkEl}.</span>
		) : (
			<span>
				Since you are keeping books, your refund will be $
				{refund.totalPricePaid}&nbsp;-&nbsp;$
				{nonRefundAmount}&nbsp;=&nbsp;$
				{refund.subscriptionRefundTotal} less applicable taxes.
			</span>
		);
		reminderEl = (
			<div>
				*Cancelling the online portion of a Bundle forfeits the Bundle discount.{" "}
				{calculationEl}
			</div>
		);
	}
	return {
		title: `Cancel Bundle for ${name}`,
		message: messageEl,
		reminder: reminderEl,
	};
};

const getNonBundleCancelCopy = function(styles, student, students) {
	const {subscription} = student;
	const name = student.displayName;
	const type = subscription.planType;
	const hasOthersOfType = _.find(
		students,
		s =>
			s.subscription.active &&
			s.subscription.planType === type &&
			s.userID !== student.userID
	);
	let middle = null;
	if (!subscription.usedB2BBulkCode && hasOthersOfType) {
		middle = (
			<p className={styles.cancelModalP}>
				{`Because you have multiple ${type} subscriptions active on your account,
      your refund will be based on the discounted multi\u2011student rate.`}
			</p>
		);
	}
	const messageEl = (
		<div>
			<p className={styles.cancelModalP}>
				{`Are you sure you want to cancel this subscription? ${name} will immediately lose access to BA Online.`}
			</p>
			{middle}
			<p className={styles.cancelModalP}>
				<Link
					to={URLMake.forParentSupport("account", "canceling-subscription")}
					className={styles.link}
					noFocus={true}
					isNewTab={true}
				>
					{`Review our subscription cancellation policies.`}
				</Link>
			</p>
		</div>
	);
	return {
		title: `Cancel subscription for ${name}`,
		message: messageEl,
	};
};

const getCancelSuccessCopy = function(
	styles,
	displayName,
	planType,
	usedB2BBulkCode,
	refundBooks,
	refundOnline
) {
	let title;
	let messageEl = null;
	let booksText = "";
	let whyText = "";
	let textboxLabel = "";
	let textboxNotification = "";
	const subscriptionText =
		planType === "bundle" && !refundOnline
			? ""
			: `You have canceled ${displayName}'s subscription.`;
	const refundWindowLengthText = refundBooks
		? "10-15 business days of receipt of books in retail condition"
		: "7-10 business days";
	const refundEl = usedB2BBulkCode ? null : (
		<p>
			<b>Your refund will be processed within {refundWindowLengthText}.</b>
		</p>
	);

	if (planType === "bundle") {
		title = "Thank You for Trying Beast Academy";
		booksText = refundBooks
			? `You have chosen to return ${displayName}'s books.`
			: "";
		whyText = "Please tell us why you are canceling/returning:";
		messageEl = (
			<span>
				{subscriptionText}
				<br />
				{booksText}
				{refundEl}
				{whyText}
			</span>
		);
	} else {
		title = "Thank You for Trying BA Online";
		const vcEl = (
			<p>
				<b>Prefer a live instructor for your student?</b> Check out{" "}
				<Link
					className={infoStyles.link}
					to="https://virtual.aopsacademy.org/"
					isExternal={true}
					isNewTab={true}
				>
					AoPS Academy Virtual Campus
				</Link>
				, from the makers of Beast Academy.
			</p>
		);
		whyText = "Please tell us why you are canceling:";
		messageEl = (
			<span>
				<p>{subscriptionText}</p>
				{refundEl}
				{vcEl}
				{whyText}
			</span>
		);
		textboxLabel = "How can we improve Beast Academy Online?";
		textboxNotification = "Please enter your answer below.";
	}

	return {
		title,
		message: messageEl,
		submitted: "Your note has been submitted.",
		textboxLabel,
		textboxNotification,
	};
};

const getCancelSuccessOptionsCopy = function(styles, planType) {
	// NOTE: If adding a new option that has a label that isn't just plain text
	// You need to add a reasonText so we have a string version of the reason
	const options = [
		{
			key: "changingSubscriptionType",
			label: (
				<span>
					I'm changing my subscription type.
					<span
						className={styles.additionalText}
						onClick={evt => evt.stopPropagation()}
					>
						<a
							className={styles.link}
							target="_blank"
							href={URLMake.forParentSupport(
								"account",
								"changing-subscription"
							)}
						>
							Here's how to make changes
						</a>
						.
					</span>
				</span>
			),
			reasonText: "I'm changing my subscription type.",
		},
		{key: "tooExpensive", label: "The price did not fit my budget."},
		{
			key: "mathTooDifficult",
			label: "The math was more difficult than I expected.",
		},
		{
			key: "readingTooDifficult",
			label: "My child struggled with the reading involved.",
		},
		{
			key: "switchingToCompetitor",
			label:
				"I'm switching to a different company's program (please specify below).",
			showNotification: true,
		},
		{
			key: "missingFeatures",
			label: "Missing features (please explain below).",
			showNotification: true,
		},
		{
			key: "other",
			label: "Other (please explain below).",
			showNotification: true,
		},
	];

	if (planType !== "bundle") {
		options.unshift({
			key: "switchingToBooks",
			label: "I'm switching to Beast Academy books.",
		});
	}

	return options;
};

const getHearAboutBaSurveyTitleCopy = function() {
	return HEAR_ABOUT_BA_SURVEY_TITLE;
};

const getHearAboutBaSurveyOptionsCopy = function() {
	return HEAR_ABOUT_BA_SURVEY_OPTIONS;
};

const getCancelOtherSubscriptionFirstCopy = function(
	styles,
	hasMultipleSubscriptionsToCancel
) {
	const multiPrice = StringUtil.toPrice(dbShop["beast-yearly"].multiPrice);
	return (
		<div>
			<div>
				This is your primary Yearly subscription. To cancel this subscription,
				you must first cancel your discounted {multiPrice} Yearly subscription
				{hasMultipleSubscriptionsToCancel ? "s" : ""}, whose discounted rate was
				based on this subscription. You can reactivate any cancelled
				subscription at any time. All settings and progress will be saved.
			</div>
			<br />
			<Link
				to={URLMake.forParentSupport("account", "canceling-subscription")}
				isNewTab={true}
				className={styles.link}
			>
				Review our subscription cancellation policies.
			</Link>
		</div>
	);
};

const getCannotUnlockCopy = function(parent, child) {
	return `The ${parent} must first be unlocked to unlock this ${child}.`;
};

const LEVEL_1_DISCOUNT = 48;
const STANDARD_DISCOUNT = 60;

const getBundleModalCopy = function(isLevel1BookSet) {
	// There's a different discount if the only book set is Level 1 (which is currently $12 cheaper than the other book sets).
	const discount = isLevel1BookSet ? LEVEL_1_DISCOUNT : STANDARD_DISCOUNT;
	return {
		title: "Create A Bundle",
		details: (
			<span>
				You will save up to ${discount} by bundling items already in your cart.
				<br />
				Choose a book set and a yearly subscription to bundle below.
			</span>
		),
		singleOption: (
			<span>
				You will save ${discount} by bundling items already in your cart.
				<br />
				Click the button below to bundle these items and save.
			</span>
		),
	};
};

const getSuggestBundleCopy = function(info = {}) {
	const {missingBooks, priceDiff, subName, gradeNumber} = info;
	const price = StringUtil.toShortPrice(Math.abs(priceDiff));
	let sugg;
	if (missingBooks.length) {
		if (priceDiff < 0) {
			sugg = `You can add ${StringUtil.combineNames(
				missingBooks
			)} and pay ${price} less by bundling ${subName}'s subscription with books.`;
		} else if (priceDiff > 0) {
			sugg = `You can add ${StringUtil.combineNames(
				missingBooks
			)} for only ${price} more by bundling ${subName}'s subscription with books.`;
		} else {
			sugg = `You can add ${StringUtil.combineNames(
				missingBooks
			)} for no additional cost by bundling ${subName}'s subscription with books.`;
		}
	} else {
		sugg = `You have a full set of BA ${gradeNumber} books and a Monthly subscription for ${subName} in your cart. You can replace these with a BA ${gradeNumber} Bundle to get a full year of BA Online for only ${price} more.`;
	}

	return (
		<>
			<p>{sugg}</p>
			<p>
				{"Do you want to make " +
					subName +
					"'s subscription a BA\u00a0" +
					gradeNumber +
					"\u00a0Bundle?"}
			</p>
		</>
	);
};

const getCreateAccountCopy = function(isNewAccount, user) {
	let text = "Sign in to your account";
	if (isNewAccount) text = "Set up your Parent Account below.";
	else if (user)
		text = `Your ${_.get(
			user,
			"model.email"
		)} account will be your Parent Account. `;
	return (
		<span>
			You will need a Parent Account to use Beast Academy Online.
			<br />
			{text}
		</span>
	);
};

const getSharedAccountCopy = function(email) {
	return `Beast Academy Online shares an account system with other AoPS websites: Art of Problem Solving and AoPS Academy. Since you already have an account under ${email}, you must sign in to complete Beast Academy Online account setup.`;
};

const getExistingAccountErrorCopy = function() {
	return "This account already exists. You must be a new user to use subscription codes.";
};

const getItemizeCopy = function() {
	return {
		apparel: "Apparel",
		books: "Books",
		subscriptions: "Subscriptions",
		bundles: "Bundles",
		booksRefund: "Book Refunds",
		subscriptionsRefund: "Subscription Cancellations",
		bundlesRefund: "Bundle Cancellations",
		code: "Yearly Subscription Codes",
		gift: "1-Year Subscription Gifts",
	};
};

const getBundleRecommendationsCopy = function(styles, grade) {
	// TODO: maybe do a computation to get that 42? But there's hard-coded 54s
	// and 42s in this file already...
	return (
		<div className={styles.bundleRecommendation}>
			You have a full grade set ({grade}
			A-
			{grade}
			D) of books in your cart.
			<br />
			You can add 1 year of BA Online for just $42 more by buying a bundle.
			<br />
			<Link to={URLMake.forEnroll()} className={styles.link}>
				Click here to learn more
			</Link>
			.
		</div>
	);
};

const forAccountPageLoadError = function(type) {
	const baseMessages = {
		subscriptions: "There was an issue loading your subscriptions.",
		account: "There was an issue loading your account information.",
		upcomingPayments:
			"There was an issue loading the next payment on your account.",
		pastPayments: "There was an issue loading past payments on your account.",
		default: "Something failed to load properly.",
	};
	return `${baseMessages[type] ||
		baseMessages.default} Click the button below to try again.`;
};

const getCheckoutSubscribeCopy = function(location) {
	const text =
		location === "contact"
			? `Yes, I would like to receive Beast Academy product updates, announcements, and other outreach emails. You can unsubscribe at any time.`
			: `Yes, I'd like to receive monthly newsletters and promotions from Beast Academy.  I'm 16 or older. I can unsubscribe anytime.`;

	return text;
};

const getStudentInActiveClassesMessage = function(
	displayName,
	styles,
	accessEndsAt
) {
	const accessEndDate = accessEndsAt ? moment(accessEndsAt).format("ll") : null;
	const enrollmentAccessText = accessEndDate
		? `has access to BAO via their class enrollment until ${accessEndDate}`
		: "has access to BAO via their class enrollment";
	return (
		<p>
			Your student, {displayName}, {enrollmentAccessText}.{" "}
			<a
				href={URLMake.forParentSupport("contact")}
				target="_blank"
				rel="noopener noreferrer"
				className={styles.link}
			>
				Contact our team
			</a>{" "}
			if you require assistance.
		</p>
	);
};

const getPurchaseOrderAccountSetupCopy = function(hasMultipleStudents) {
	return `Click continue to view the Reports page of your Parent Account. There, you can set up your Student Account${
		hasMultipleStudents ? "s" : ""
	}.`;
};

const getSubscriptionChangeCommentCopy = function(styles) {
	return (
		<p className={styles.commentCopy}>
			Trying to combine this purchase with other items in your cart? You'll need
			to make a separate order. Please note in the comment field of your{" "}
			<b>second</b> order to have your orders combined to be eligible for free
			shipping.
		</p>
	);
};

const getRedeemCodeStepCopy = function() {
	return {
		title: "Get started with your subscription to Beast Academy Online",
		description:
			"If you have a gift code, Save with Friends code, or ClassWallet code, you're in the right spot! Enter your code below.",
		tooltip:
			"Subscription codes refer to codes acquired through our Save With Friends or gifting programs. If you have a code from Give3Get3, please apply the code during checkout.",
		codeRedeemSuccessMessage: "Code verified.",
	};
};

const getRedeemAccountStepCopy = function(styles, linkClickAction) {
	return {
		title: "Parent Account Information",
		description: (
			<div className={styles.bodyText}>
				{"Create a Parent Account. Already have one? "}
				<a href="#" className={styles.link} onClick={linkClickAction}>
					Sign in
				</a>
				{"."}
			</div>
		),
	};
};

const getRedeemStudentLoggedOutStepCopy = function() {
	return {
		title: "Add a Student",
		description:
			"Add a student to use your subscription code. You'll be able to add another student after setting up your account.",
	};
};

const getRedeemConfirmationStepCopy = function(user, styles) {
	return {
		newParentTitle:
			"Check your inbox to finish setting up your Beast Academy Online account!",
		newParentDescription: `We've sent confirmation details to ${user.email} to activate your Beast Academy Online subscription. Your mathematical journey awaits!`,
		newParentHelpText: (
			<>
				If you did not receive an email or if you're running into any issues,
				contact us at{" "}
				<a href="mailto:info@beastacademy.com" className={styles.link}>
					info@beastacademy.com
				</a>
				.
			</>
		),
		existingParentTitle: `Twelve months have been applied to ${user.studentName}'s Beast Academy Online subscription`,
		existingParentDescription:
			"Congratulations! You've used your code to add to your subscription to Beast Academy Online. Full speed ahead!",
	};
};

// const getRedeemUnauthorizedUserCopy = function() {};

// Displays banner on all checkout pages when shippable item in cart
const getShippingNotice = function(styles, blockedAddress) {
	// Note: keep this functionallity around for later use after re-enabling

	// If a particular country is blocked, use the commented code to split based on that.
	// Otherwise, for general shipping messages, just return the uncommented bit.

	if (blockedAddress) {
		return (
			<div className={styles.shippingNotice}>
				We are not able to ship to the country/address that you provided at this
				time. We apologize for the inconvenience. We recommend that you use{" "}
				<a href={URLMake.forBAOnline()} className={styles.link}>
					Beast Academy Online
				</a>{" "}
				to access the Beast Academy Guide books as well as over 10,000 problems
				like those in the Beast Academy Practice books.
			</div>
		);
	} else {
		return null;
	}
	// Uncomment the notice below to display a notice in the cart for
	// any cart with items that needs shipping
	// return (
	// 	<div className={styles.shippingNotice}>
	// 		{`NOTE: Customers may experience some delay in receiving shipments due to
	// 					the recent worldwide disruptions due to COVID-19. If you need access quickly,
	// 					we recommend using `}
	// 		<a href={URLMake.forBAOnline()} className={styles.link}>
	// 			Beast Academy Online
	// 		</a>
	// 		{` to access the Beast Academy Guide books as well as over 10,000 problems
	// 					like those in the Beast Academy Practice books.`}
	// 	</div>
	// );
};

const getExchangeRatesMessageForOrder = function(styles, isInternational) {
	return isInternational ? (
		<div className={styles.exchangeRatesNotice}>
			All amounts are in US Dollars. Please note that if you pay in another
			currency then need a refund issued, the refund will likely be different
			than the exact charged amount, due to fluctuating exchange rates and
			international transaction fees charged by your credit card.
		</div>
	) : null;
};

const getTeacherTutorialModal = function(styles, user) {
	const hasRostering = OpsUser.hasRosteringTab(user);
	const isAdmin = OpsUser.isPurchaseAdmin(user);
	const isSchoolAdmin = OpsUser.isSchoolAdmin(user);

	let supportLink = "play";

	// school admins and purchase admins with < 100 students should go to /support/accounts
	if (isSchoolAdmin) {
		supportLink = "accounts";
	} else if (isAdmin) {
		supportLink = hasRostering ? "rostering" : "accounts";
	}

	const role = isAdmin || isSchoolAdmin ? "admin" : "teacher";
	const supportPagesExplanationText =
		isAdmin || isSchoolAdmin
			? `how to create classes and users, how students play, how to read progress reports`
			: `how students play, how to read reports`;
	const contactText = isAdmin
		? `Contact us at schools@BeastAcademy.com if you have any questions or need help getting started.`
		: `If you have questions or need help getting started, contact your administrator or
		email us at schools@BeastAcademy.com.`;

	return {
		welcome: {
			contents: (
				<div className={styles.welcomeModalContents}>
					<p>{`Welcome to your Beast Academy Online ${role} account!`}</p>

					<p>
						{`Need help finding your way around?`}
						<br />
						{`Our `}
						<Link
							className={styles.link}
							to={URLMake.forSchoolSupport(supportLink)}
						>
							Support Pages
						</Link>
						{` explain ${supportPagesExplanationText}, our available planning tools,
					and much more.`}
					</p>
					<p>{contactText}</p>
				</div>
			),
			title: "WELCOME!",
			buttonText: "GOT IT!",
		},
	};
};

// Parent Tutorial modal
const getParentTutorialModal = function(styles, studentName) {
	return {
		registrationSuccess: {
			// deprecated for now
			contents: (
				<div className={styles.tutorialContents}>
					<p>
						{`${studentName}'s subscription is all set up! Watch the video below for
						a broad overview of how Beast Academy Online works.`}
					</p>
					<iframe
						className={styles.video}
						// Older video still exists at B_AAuG6kGGg (has Tasha's voice)
						// Old video still exists at cflt-kv-0Jk
						src="https://www.youtube.com/embed/K3shgfL4WHY"
						frameBorder="0"
						allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
					/>
					<p>
						<a
							className={styles.link}
							href={URLMake.forParentSupport("play")}
							target="_blank"
						>
							Learn more about navigating Beast Academy Online on our Help Site.
						</a>
					</p>
				</div>
			),
			title: "SUCCESS!",
			buttonText: "GOT IT",
		},
		supportMenu: {
			contents: (
				<div className={styles.tutorialContents}>
					<p>
						{`You can always learn more about using Beast Academy from the `}
						<a
							className={styles.link}
							href={URLMake.forParentSupport("getstarted")}
						>
							SUPPORT
						</a>
						{` pages.`}
						<span className={styles.mobile}>{` in the main menu.`}</span>
					</p>
				</div>
			),
			title: "SUPPORT",
			buttonText: "GOT IT",
		},
	};
};

module.exports = {
	getHowViewCopy,
	getContactCopy,
	getBottomBarCopy,
	getBookOffers,
	getCodeOffers,
	getCheckoutConfirmCopy,
	getShippingCopy,
	getFormErrorCopy,
	getFormInvalidCopy,
	getCouponErrorCopy,
	getCvvBlurb,
	get404Copy,
	getEmailModalCopy,
	getMessageModalCopy,
	getMailListPageCopy,
	getConfirmEmailCopy,
	getEnableAutoRenewCopy,
	getMailingListRoles,
	getDisconnectCopy,
	shippingTypes,
	getPOCopy,
	getCheckoutErrorCopy,
	getRecurringBillingCopy,
	getParentErrorCopy,
	getTeacherErrorCopy,
	getBeyondBACopy,
	getResourcesCopy,
	getTeacherPagesCopy,
	getUnsupportedBrowserCopy,
	getReturnPolicy,
	getTaxExemptPolicy,
	getCancellationPolicy,
	getRenewalPolicy,
	getCodeTermsAndConditions,
	getPolicyModalNotifications,
	getChooseSubscriptionsCopy,
	getChooseSubscriptionBlockingMessages,
	getDisplayNameCopy,
	getBundleSelectionCopy,
	getResetCopy,
	getTryAgain,
	getChangeEmailCopy,
	forChangeEmailError,
	getAccountOptions,
	getAccountPlanCopy,
	getAcceptTermsCopy,
	getAcceptCoppaCopy,
	getRenewConfirmCopy,
	getDeleteCardConfirm,
	getBundleCancelCopy,
	getNonBundleCancelCopy,
	forUnregisteredStudentReport,
	getParentStudentRegistrationCopy,
	getLevelExplanationCopy,
	getCannotUnlockCopy,
	getCardWarningCopy,
	getClassWalletSubscriptionCopy,
	getSubscriptionsWarning,
	getChangeSubscriptionNote,
	getSubscriptionChangeWarning,
	getCouponExtraCopy,
	getBundleModalCopy,
	getSuggestBundleCopy,
	getCreateAccountCopy,
	getSharedAccountCopy,
	getExistingAccountErrorCopy,
	getItemizeCopy,
	getBundleRecommendationsCopy,
	forAccountPageLoadError,
	getCheckoutSubscribeCopy,
	getStudentInActiveClassesMessage,
	getCancelRefundCopy,
	getCancelSuccessCopy,
	getCancelSuccessOptionsCopy,
	getHearAboutBaSurveyTitleCopy,
	getHearAboutBaSurveyOptionsCopy,
	getCancelOtherSubscriptionFirstCopy,
	getPurchaseOrderAccountSetupCopy,
	getApparelDescription,
	getRedeemCodeStepCopy,
	getRedeemAccountStepCopy,
	getRedeemStudentLoggedOutStepCopy,
	getRedeemConfirmationStepCopy,
	getCalendarInfoCopy,
	getSubscriptionChangeCommentCopy,
	getShippingNotice,
	getExchangeRatesMessageForOrder,
	getTeacherTutorialModal,
	getParentTutorialModal,
};
